webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_config__);



var Config = {
  api_url: __WEBPACK_IMPORTED_MODULE_0__config_config___default.a.reqDomains()
};

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  "data-v-78c62f12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.resize = function () {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 320;

  var _width = document.documentElement.clientWidth;
  console.log('屏幕宽度: ' + _width);
  var ratio = _width / width;
  ratio = ratio > 2 ? 2 : ratio;
  document.getElementsByTagName('html')[0].style.fontSize = 16 * ratio + 'px';
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.wordChange = function (words) {
  var oldWords = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(words));
  var newWords = '';
  oldWords.forEach(function (value) {
    var spaceWord = /^[▪•●·.。`,，？?]+$/;
    var flags = spaceWord.test(value);
    if (flags) {
      value = '·';
    }
    newWords += value;
  });
  return newWords;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.debugConsole = function () {
  ;(function () {
    var src = '//cdn.bootcss.com/eruda/1.4.2/eruda.min.js';
    if (!/debug=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
  })();
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.htmlDecodeString = function (text) {
  var temp = document.createElement('div');
  temp.innerHTML = text;
  var output = temp.innerText || temp.textContent;
  temp = null;
  return output;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.htmlEncode = function (html) {
  var temp = document.createElement('div');
  temp.textContent != null ? temp.textContent = html : temp.innerText = html;
  var output = temp.innerHTML;
  temp = null;
  return output;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.getQueryString = function (variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.sortAB = function (a, b) {
  var c = [];
  for (var i in a) {
    for (var j in b) {
      if (a[i].index === b[j].index) {
        c.push(b[j]);
        continue;
      }
    }
  }
  return c;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.arrayInData = function (arr, key, item) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key] === item) {
      return true;
    }
  }
  return false;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.isInArray = function (arr, key) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === key) {
      return true;
    }
  }
  return false;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.arrayRemoveNull = function (arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === null || arr[i] === '' || arr[i] === undefined) {
      arr.splice(i, 1);
      i = i - 1;
    }
  }
  return arr;
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.isUndefine = function (key, value) {
  if (key !== undefined) {
    return key;
  } else {
    return value;
  }
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.setCookie = function (cname, cvalue, domain, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';domain=' + domain + '; path=/;' + expires;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.isIOS = function () {
  var isIphone = navigator.userAgent.includes('iPhone');
  var isIpad = navigator.userAgent.includes('iPad');
  return isIphone || isIpad;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.checkScript = function (text) {
  var flag = false;
  var scriptWord = "<|>|script|alert|{|}|#|$|'|\"|:|;|&|*|@|@|%|^|?";
  var words = scriptWord.split('|');
  for (var i = 0; i < words.length; i += 1) {
    if (text.indexOf(words[i]) !== -1) {
      flag = true;
      break;
    }
  }
  return flag;
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.idCheck = function (idcard) {
  var area = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' };
  var Y, JYM;
  var S, M;
  var idcard_array = idcard.split('');

  if (area[parseInt(idcard.substr(0, 2))] === null) {
    return false;
  }

  switch (idcard.length) {
    case 18:
      var ereg;
      if (parseInt(idcard.substr(6, 4)) % 4 === 0 || parseInt(idcard.substr(6, 4)) % 100 === 0 && parseInt(idcard.substr(6, 4)) % 4 === 0) {
        ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
      } else {
        ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
      }
      if (ereg.test(idcard)) {
        S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
        Y = S % 11;
        M = 'F';
        JYM = '10X98765432';
        M = JYM.substr(Y, 1);
        if (M == idcard_array[17].toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
      break;
    default:
      return false;
      break;
  }
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  "data-v-70649c22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-4041bc6b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYNC_TOAST_STATE; });

var SYNC_TOAST_STATE = 'SYNC_TOAST_STATE';

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  "data-v-86ca97ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  "data-v-11c4ed8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  "data-v-95eb8dd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-3d77fdd1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  "data-v-0c85e872",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */,
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_login__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_login_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_order_orderQuery__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_order_orderQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_order_orderQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_order_applyClaim__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_order_applyClaim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_order_applyClaim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_learn__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_order_learn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_order_learn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sign_signer__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sign_signer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sign_signer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_order_FAQ__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_order_FAQ___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_order_FAQ__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_order_myOrderInfo__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_order_myOrderInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_order_myOrderInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_order_settlementInfo__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_order_settlementInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_order_settlementInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_index__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_driverSchool_login__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_driverSchool_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_driverSchool_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_driverSchool_checkType__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_driverSchool_checkType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_driverSchool_checkType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_driverSchool_toubaoManager__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_driverSchool_toubaoManager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_driverSchool_toubaoManager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_driverSchool_toubaoView__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_driverSchool_toubaoView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_driverSchool_toubaoView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_driverSchool_toubaoStudent__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_driverSchool_toubaoStudent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_driverSchool_toubaoStudent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_driverSchool_myOrders__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_driverSchool_myOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_driverSchool_myOrders__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/newBaoPublic',
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  },
  routes: [{
    path: '/dirverLogin',
    name: 'dirverLogin',
    component: __WEBPACK_IMPORTED_MODULE_14__views_driverSchool_login___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/checkType',
    name: 'checkType',
    component: __WEBPACK_IMPORTED_MODULE_15__views_driverSchool_checkType___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/toubaoManager',
    name: 'toubaoManager',
    component: __WEBPACK_IMPORTED_MODULE_16__views_driverSchool_toubaoManager___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/toubaoView',
    name: 'toubaoView',
    component: __WEBPACK_IMPORTED_MODULE_17__views_driverSchool_toubaoView___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/toubaoStudent',
    name: 'toubaoStudent',
    component: __WEBPACK_IMPORTED_MODULE_18__views_driverSchool_toubaoStudent___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/myOrders',
    name: 'myOrders',
    component: __WEBPACK_IMPORTED_MODULE_19__views_driverSchool_myOrders___default.a,
    meta: {
      requireAuth: false,
      allowBack: false
    }
  }, {
    path: '/index',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home___default.a,
    meta: {
      allowBack: false
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_login_login___default.a,
    meta: {
      requireAuth: true,
      allowBack: true
    }
  }, {
    path: '/orderQuery',
    name: 'orderQuery',
    component: __WEBPACK_IMPORTED_MODULE_4__components_order_orderQuery___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }, {
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_11__views_index___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }, {
    path: '/myOrder/:credId',
    name: 'myOrder',
    component: __WEBPACK_IMPORTED_MODULE_9__components_order_myOrderInfo___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }, {
    path: '/settlementInfo/:credId',
    name: 'settlementInfo',
    component: __WEBPACK_IMPORTED_MODULE_10__components_order_settlementInfo___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }, {
    path: '/learn',
    name: 'learn',
    component: __WEBPACK_IMPORTED_MODULE_6__components_order_learn___default.a,
    meta: {
      requireAuth: true,
      allowBack: true
    }
  }, {
    path: '/signer',
    name: 'signer',
    component: __WEBPACK_IMPORTED_MODULE_7__components_sign_signer___default.a,
    meta: {
      requireAuth: true,
      allowBack: true
    }
  }, {
    path: '/applyClaim',
    name: 'applyClaim',
    component: __WEBPACK_IMPORTED_MODULE_5__components_order_applyClaim___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }, {
    path: '/FAQ',
    name: 'FAQ',
    component: __WEBPACK_IMPORTED_MODULE_8__components_order_FAQ___default.a,
    meta: {
      requireAuth: true,
      allowBack: false
    }
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_topImg__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(266);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* actions */],

  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    topImg: __WEBPACK_IMPORTED_MODULE_3__modules_topImg__["a" /* default */]
  },
  strict: false
}));

/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(488),
  /* scopeId */
  "data-v-c1056730",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Env = __webpack_require__(239);

var _reqDomains = {
  dev: 'http://localhost:8081/',
  test: 'http://www.chubbyface.top/',

  pro: 'http://new.ynyzxjy.cn/'
};

var httpRoots = {
  dev: 'http://localhost:8081/newBaoPublic/',
  test: 'http://www.chubbyface.top/newBaoPublic/',

  pro: 'http://new.ynyzxjy.cn/newBaoPublic/'
};

function parse(config) {
  switch (Env.env) {
    case 'production':
      return config.pro;
    case 'test':
      return config.test;
    default:
      return config.dev;
  }
}

module.exports = {
  reqDomains: function reqDomains() {
    return parse(_reqDomains);
  },
  httpRoot: function httpRoot() {
    return parse(httpRoots);
  }
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  env: "production" || 'dev'
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_common__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.resize(375);
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "loading",
    data: function data() {
        return {
            loadingFlag: false,
            loadingText: ""
        };
    },

    watch: {
        loadingText: function loadingText() {
            this.loadingFlag = !!this.loadingText;
        },
        loadingFlag: function loadingFlag() {
            if (!this.loadingFlag) {
                this.loadingText = "";
            }
        }
    }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "maskDiv",
  data: function data() {
    return {
      maskFlag: false
    };
  },

  watch: {}
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "popup",
  data: function data() {
    return {
      popupShowFlag: false,
      popupShowText: ''
    };
  },

  methods: {
    popupShowing: function popupShowing(text, sec) {
      var _this = this;

      var second = sec || 3000;
      this.popupShowFlag = true;
      this.popupShowText = text;
      setTimeout(function () {
        _this.popupShowFlag = false;
      }, second);
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      userRole: '0'
    };
  },
  mounted: function mounted() {
    this.userRole = this.$route.query.role || '0';
    if (this.userRole === '0') {
      if (this.getCookie('userInfo')) {
        this.$router.push('/user');
      } else {
        this.$router.push('/login?role=0');
      }
    } else {
      if (this.getCookie('merchantInfo')) {
        this.$router.push('/writeOff');
      } else {
        this.$router.push('/login?role=1');
      }
    }
  },

  methods: {},
  computed: {},
  components: {}
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_toast_style__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_progress_style__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_progress__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_loading_style__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_loading__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_commonComponents_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_commonComponents_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_commonComponents_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_commonComponents_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_commonComponents_maskDiv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_commonComponents_maskDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_commonComponents_maskDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_reset_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_qs__);

















__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vant_es_progress__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_5_vant_es_loading__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "login",
  data: function data() {
    return {
      loading: false,
      isState: false,
      processFlag: false,
      ewmUrl: '',
      token: '',
      checkIN: '',
      checkINCount: 0,
      processNum: 0,
      processTime: '',
      bdOrderInfo: {},
      stateType: 1,
      errorDesc: ''
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_7__common_commonComponents_popup___default.a,
    ajaxLoading: __WEBPACK_IMPORTED_MODULE_8__common_commonComponents_loading___default.a,
    maskPopup: __WEBPACK_IMPORTED_MODULE_9__common_commonComponents_maskDiv___default.a
  },
  mounted: function mounted() {
    document.getElementsByTagName('title')[0].innerText = '扫码登录';
    this.bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
    this.restImage();
  },

  methods: {
    restImage: function restImage() {
      this.loading = false;
      this.isState = false;
      this.processFlag = false;
      this.ewmUrl = '';
      this.token = '';
      this.checkIN = '';
      this.checkINCount = 0;
      this.processNum = 0;
      this.processTime = '';
      this.bdOrderInfo = {};
      this.stateType = 1;
      this.errorDesc = '';

      this.getLoginImage();
      clearInterval(this.checkIN);
    },
    getLoginImage: function getLoginImage() {
      var that = this;
      var url = __WEBPACK_IMPORTED_MODULE_10__common_api__["a" /* Config */].api_url + "applets-server/api/screenshots/getLoginQrCode";
      var bdOrderInfoTemp = JSON.parse(localStorage.getItem('bdOrderInfo'));
      console.log("bdOrderInfoTemp", bdOrderInfoTemp);
      this.$ajax({
        method: "post",
        url: url,
        data: {
          claimId: bdOrderInfoTemp.policyId,
          lpkm: bdOrderInfoTemp.claimClassCode,
          kssj: bdOrderInfoTemp.policyTime
        }
      }).then(function (res) {
        var data = res.data;
        that.ewmUrl = 'data:image/png;base64,' + data.data.img;
        sessionStorage.setItem("123token", data.data.token);
        that.getStatus();
      });
    },
    getStatus: function getStatus() {
      var that = this;
      var token = sessionStorage.getItem('123token');
      var url = __WEBPACK_IMPORTED_MODULE_10__common_api__["a" /* Config */].api_url + "applets-server/api/screenshots/getStatus/" + token;
      if (token) {
        this.$ajax({
          method: "get",
          url: url
        }).then(function (res) {
          var data = res.data;
          console.log("扫码状态", data.data.code == '201');
          if (data.data.code == '200') {
            that.getImage(token);
            clearInterval(that.checkIN);
          } else {
            if (data.data.code == '400') {
              this.$message({
                type: "error",
                message: "二维码已失效，请重新扫码"
              });
              that.getLoginImage();
            } else {

              that.getStatus();
            }
          }
        });
      }
    },
    getImage: function getImage(token) {
      var that = this;
      console.log("开始进行处理");
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_10__common_api__["a" /* Config */].api_url + "applets-server/api/screenshots/getScreenshots/" + token
      }).then(function (res) {
        console.log("res--------------------", res);
        that.$refs.maskShow.maskFlag = true;
        that.processFlag = true;
        that.processNum = res.data.data;
        if (res.data.data == 100) {
          that.processNum = 100;
          that.isState = true;
          that.$refs.maskShow.maskFlag = false;
          that.processFlag = false;
          that.stateType = 1;
        } else {
          setTimeout(function () {
            that.getImage(token);
          }, 2000);
        }
      });
    },
    getResultImg: function getResultImg() {
      var that = this;
      var bdOrderInfoTemp = JSON.parse(localStorage.getItem('bdOrderInfo'));
      console.log("bdOrderInfoTemp", bdOrderInfoTemp);
      console.error("infossssss", {
        imageId: localStorage.getItem('infoToken'),
        test_kskm: bdOrderInfoTemp.claimClassCode,
        policyId: bdOrderInfoTemp.policyId
      });
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_10__common_api__["a" /* Config */].api_url + 'py_insure/picturesave',
        data: __WEBPACK_IMPORTED_MODULE_13_qs___default.a.stringify({
          imageId: localStorage.getItem('infoToken'),
          test_kskm: bdOrderInfoTemp.claimClassCode,
          policyId: bdOrderInfoTemp.policyId
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        var data = res.data;
        that.isState = true;
        that.$refs.maskShow.maskFlag = false;
        that.processFlag = false;
        clearInterval(that.checkIN);
        if (data.code == '200') {
          that.stateType = 1;
        } else {
          that.stateType = 2;
          that.errorDesc = data.data;
        }
      }).catch(function (err) {
        clearInterval(that.checkIN);
        that.errorDesc = err;
        __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["a" /* default */].success('访问异常，请重新尝试扫码');
        setTimeout(function () {
          that.restImage();
        }, 3000);
      });
    },
    getProcess: function getProcess() {
      var bdOrderInfoTemp = JSON.parse(localStorage.getItem('bdOrderInfo'));
      var that = this;
      this.checkIN = setInterval(function () {
        that.checkINCount++;
        if (that.checkINCount >= 300) {
          clearInterval(that.checkIN);
        }
        that.$ajax({
          method: "post",
          url: __WEBPACK_IMPORTED_MODULE_10__common_api__["a" /* Config */].api_url + 'py_insure/picturesearch',
          data: __WEBPACK_IMPORTED_MODULE_13_qs___default.a.stringify({
            imageId: localStorage.getItem('infoToken'),
            policyId: bdOrderInfoTemp.policyId
          }),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (res) {
          var data = res.data;
          if (!that.ewmUrl && data.code == '200') {
            that.ewmUrl = 'data:image/png;base64,' + data.data;
          }
          if (data.code == '201') {
            that.$refs.maskShow.maskFlag = true;
            that.processFlag = true;
            if (!that.processTime) {
              that.processNum = 1;
              that.processTime = setInterval(function () {
                that.processNum += 1;
                if (that.processNum == 30) {
                  clearInterval(that.processTime);
                }
              }, 500);
            }
          } else if (data.code == '202') {
            clearInterval(that.processTime);
            that.$refs.maskShow.maskFlag = true;
            that.processFlag = true;
            if (data.pictureNum && data.pictureNum != 0) {
              var num = 30 + parseInt(data.pictureNum || 0) * 10;
              that.processNum = num > 99 ? 99 : num;
            }
          }
        }).catch(function (err) {});
      }, 1000);
    }
  },
  watch: {}
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_collapse_style__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_collapse__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_collapse_item_style__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_collapse_item__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_icon_style__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_icon__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);











__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_collapse__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_3_vant_es_collapse_item__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_5_vant_es_icon__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "applyClaim",
  data: function data() {
    return {
      activeNames: 0,
      faqList: [{
        question: '挂科时间多久申请补偿？',
        answer: '挂科后尽快申请补偿，保司补偿标准为挂一科补偿一科，单科发起时间不得超过30个自然日，超过30个自然日，视为放弃挂科，保司不做赔付。'
      }, {
        question: '发起补偿申请后补偿款多久到账？',
        answer: '当您提交申请成功后，会审核您提交的订单，审核通过后会进行打款。您可关注牛保网点击“补偿查询”查看当前审核进度。'
      }, {
        question: '补偿款上面显示非本人收款，我找谁要补偿款？',
        answer: '补偿款统一补偿到驾校指定账户，如您查到补偿进度显示已打款，您可咨询驾校/教练。'
      }, {
        question: '补偿申请对预约考试有影响吗？',
        answer: '您在公众号提起“学员补偿”后就可以正常预考，保险与您的学车预约考试没有直接关系。'
      }, {
        question: '补偿申请时输入错误了怎么办？',
        answer: '未正确填写补偿申请将会被驳回，驳回后可以重新发起补偿。'
      }, {
        question: '我提交的补偿订单显示“驳回”状态怎么办？',
        answer: '显示“驳回”表示您提交的订单审核失败，需要重新发起补偿申请（发起补偿时请按照驳回备注检查所提交资料是否正确）。'
      }, {
        question: '拿证后如何提交补偿申请？',
        answer: '拿证后不能正常提交补偿，需要联系牛保工作人员协助处理补偿。'
      }, {
        question: '在补偿时扫描二维码显示“补偿申请失败”怎么处理？',
        answer: '补偿时生成的二维码为“动态二维码”，“动态二维码”在3分钟内未能成功扫码则会显示“补偿申请失败”，所以需在3分钟内用交管12123APP扫码。'
      }, {
        question: '成功扫码12123APP后，显示进度条不动出现卡死状态？',
        answer: '请检查网络问题，在良好的网络下重新申请补偿。'
      }, {
        question: '学员自己怎么投保？',
        answer: '本产品目前不支持学员自行在线投保，需要投保的学员请联系驾校进行投保。'
      }]
    };
  },

  components: {},
  mounted: function mounted() {
    document.title = '常见问题';
  },

  methods: {},
  watch: {}
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_datetime_picker_style__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_datetime_picker__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_picker_style__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_picker__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_checkbox_style__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_checkbox__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_uploader_style__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_uploader__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_es_toast_style__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant_es_toast__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_es_dialog_style__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vant_es_dialog__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_es_collapse_style__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vant_es_collapse__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_es_collapse_item_style__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_es_collapse_item__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vant_es_field_style__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vant_es_field__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__common_commonComponents_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_commonComponents_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_commonComponents_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__common_commonComponents_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_commonComponents_maskDiv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_commonComponents_maskDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__common_commonComponents_maskDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_reset_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__common_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_common__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sign_signer__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sign_signer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__sign_signer__);































__WEBPACK_IMPORTED_MODULE_19_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vant_es_datetime_picker__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_4_vant_es_picker__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_6_vant_es_checkbox__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_8_vant_es_uploader__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_12_vant_es_dialog__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_14_vant_es_collapse__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_16_vant_es_collapse_item__["a" /* default */]).use(__WEBPACK_IMPORTED_MODULE_18_vant_es_field__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "applyClaim",
  data: function data() {
    return {
      signShow: false,
      accountFlag: '0',
      activeNames: ['2'],
      ajaxState: true,
      selCurrentDate: '请选择挂科日期',
      currentDate: new Date(),
      position: '请选择挂科地区',
      positionCode: '',
      jxPosition: '请选择驾校所在地',
      jxPositionCode: '',
      claimClass: '请选择补偿科目',
      cxs: '',
      cxx: '',
      cxkcmc: '',
      claimClassCode: '',
      result: '未通过',
      resultCode: '2',
      score: '',
      claimFee: '0',
      password122: '',
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2045, 10, 1),
      datetimeFlag: false,
      provinceList: [],
      provinceListShowFlag: false,
      claimClassList: [],
      claimClassShowFlag: false,
      openBtn: true,
      resultList: [],
      resultShowFlag: false,
      popupType: 1,
      provinceListInit: [],
      subjectListInit: [],
      resultListInit: [],
      checked: false,
      protocolDetailFlag: false,
      userName: '',
      fileListFront: [],
      fileListBack: [],
      resizeCount: 1,
      payeeName: '',
      payeeCertNo: '',
      payeePhone: '',
      bankCode: '',
      bankName: '',
      bankProvinceName: '',
      bankCityName: '',
      bankSubName: '',
      initFlag: false,
      bankList: [],
      bankListFlag: false,
      subBankList: [],
      loading: false,
      show: false,
      signUrl: '',
      isPhone: true,
      bankSubSelectShow: false,
      firstDetailUrl: [],
      waitTestFeeUrl: [],
      testFeeUrl: [],
      stuInfoUrl: [],
      testScoreUrl: [],
      incidentSubjectUrl: [],

      autoFee: '0'
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_20__common_commonComponents_popup___default.a,
    ajaxLoading: __WEBPACK_IMPORTED_MODULE_21__common_commonComponents_loading___default.a,
    maskPopup: __WEBPACK_IMPORTED_MODULE_22__common_commonComponents_maskDiv___default.a, signer: __WEBPACK_IMPORTED_MODULE_26__sign_signer___default.a
  },
  mounted: function mounted() {
    document.title = '挂科信息';
    this.init();
    var bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
    this.jxPosition = bdOrderInfo.schoolAreaName;
    this.jxPositionCode = bdOrderInfo.schoolAreaNo;
    this.minDate = new Date(bdOrderInfo.insuranceStartTime || '2022-01-01');
    this.maxDate = new Date(bdOrderInfo.insuranceEndTime || '2032-01-01');

    var userAgent = navigator.userAgent;

    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;

    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备");
    } else {
      console.log("这是PC端");
      this.isPhone = false;
    }
  },

  methods: {
    bankSubNameClick: function bankSubNameClick() {
      this.bankSubSelectShow = true;
    },
    bankSubNameBlur: function bankSubNameBlur() {
      this.bankSubSelectShow = false;
    },
    gotoSign: function gotoSign() {
      this.signShow = true;
    },
    readBook: function readBook(val) {
      if (val) {
        this.gotoSign();
      }
    },
    setSign: function setSign(signUrl) {
      this.signUrl = signUrl;
      this.signShow = false;
    },
    deletePhoto: function deletePhoto(file, type) {
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "applets-server/api/minio/remove/cert";
      var that = this;
      this.$refs.loading.loadingFlag = true;
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          fileName: file.img
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {} else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
        }
        that.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        that.$refs.loading.loadingFlag = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */])('网络异常，请重试！');
      });
    },
    beforeRead: function beforeRead(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.resizeCount = 1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */])('图片大小不能超过10M');
        return false;
      }
      return true;
    },
    afterRead: function afterRead(file, type) {
      var _this = this;

      console.log(file);
      this.$refs.loading.loadingFlag = true;
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + 'applets-server/api/minio/upload/cert/image';
      var that = this;
      var config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      var formdata = new FormData();
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var img = new Image();
      img.src = file.content;
      console.log('0', file.content.length / 1024);
      var imageSize = file.content.length || 100;
      if (imageSize <= 10 * 1024 * 1024 && imageSize > 8 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 8 * 1024 * 1024 && imageSize > 6 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 6 * 1024 * 1024 && imageSize > 4 * 1024 * 1024) {
        this.resizeCount = 2.5;
      } else if (imageSize <= 4 * 1024 * 1024 && imageSize > 2 * 1024 * 1024) {
        this.resizeCount = 1.5;
      } else {
        this.resizeCount = 1;
      }
      console.log(this.resizeCount);
      img.onload = function () {
        if (_this.resizeCount > 1) {
          canvas.width = img.width / _this.resizeCount;
          canvas.height = img.height / _this.resizeCount;
          context.drawImage(img, 0, 0, img.width / _this.resizeCount, img.height / _this.resizeCount);
          file.content = canvas.toDataURL(file.file.type, 1);
        }
        var files = _this.dataURLtoFile(file.content, file.file.name);
        formdata.append('file', files);
        console.log('1', file.content.length / 1024);
        formdata.append('token', localStorage.getItem('infoToken'));
        _this.$ajax.post(url, formdata, config).then(function (res) {
          that.$refs.loading.loadingFlag = false;
          var data = res.data;
          if (data.success) {
            if (type == '1') {
              that.fileListFront[0].img = data.data;
            } else if (type == '2') {
              that.fileListBack[0].img = data.data;
            } else if (type == '10') {
              that.stuInfoUrl[0].img = data.data;
            } else if (type == '11') {
              that.testScoreUrl[0].img = data.data;
            } else if (type == '12') {
              that.firstDetailUrl[0].img = data.data;
            } else if (type == '13') {
              that.incidentSubjectUrl[0].img = data.data;
            } else if (type == '14') {
              that.testFeeUrl[0].img = data.data;
            } else if (type == '15') {
              that.waitTestFeeUrl[0].img = data.data;
            }
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
            if (type == '1') {
              that.fileListFront = [];
            } else if (type == '2') {
              that.fileListBack = [];
            } else if (type == '10') {
              that.stuInfoUrl = [];
            } else if (type == '11') {
              that.testScoreUrl = [];
            } else if (type == '12') {
              that.firstDetailUrl = [];
            } else if (type == '13') {
              that.incidentSubjectUrl = [];
            } else if (type == '14') {
              that.testFeeUrl = [];
            } else if (type == '15') {
              that.waitTestFeeUrl = [];
            }
          }
        }).catch(function (err) {
          that.$refs.loading.loadingFlag = false;
          if (type == '1') {
            that.fileListFront = [];
          } else {
            that.fileListBack = [];
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vant_es_toast__["a" /* default */])('网络异常，请重试！');
        });
      };
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    openDatetime: function openDatetime() {
      this.datetimeFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    cancelDatetime: function cancelDatetime() {
      this.datetimeFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    formatter: function formatter(type, val) {
      if (type === 'year') {
        return val + '\u5E74';
      } else if (type === 'month') {
        return val + '\u6708';
      } else if (type === 'day') {
        return val + '\u65E5';
      }
      return val;
    },
    queryTime: function queryTime() {
      this.datetimeFlag = false;
      this.$refs.maskShow.maskFlag = false;
      var date = new Date(this.currentDate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.selCurrentDate = year + '-' + month + '-' + day;
    },
    openCity: function openCity(type) {
      this.popupType = type;
      this.provinceListShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    onConfirmCity: function onConfirmCity(value, index) {
      if (this.popupType == 1) {
        this.position = value;
        this.positionCode = this.provinceListInit[index].areaCode;
      } else {
        this.jxPosition = value;
        this.jxPositionCode = this.provinceListInit[index].areaCode;
      }
      this.provinceListShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
      this.claimFee = 0;
      this.getClaimFee();
    },
    onCancelCity: function onCancelCity() {
      this.provinceListShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    openClaimClass: function openClaimClass() {
      this.claimClassShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    onConfirmClaimClass: function onConfirmClaimClass(value, index) {
      this.claimClass = value;
      this.claimClassCode = this.subjectListInit[index].subjectId;
      this.claimClassShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
      this.claimFee = 0;
      this.getClaimFee();
    },
    onCancelClaimClass: function onCancelClaimClass() {
      this.claimClassShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    openResult: function openResult() {
      this.resultShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    onConfirmResult: function onConfirmResult(value, index) {
      console.log('value', value);
      this.result = value;
      this.resultCode = this.resultListInit[index].resultId;
      this.resultShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    onCancelResult: function onCancelResult() {
      this.resultShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    valueCheck: function valueCheck(value, checkValue, tips) {
      if (value == checkValue) {
        this.$refs.popupShows.popupShowing(tips);
        return true;
      }
      return false;
    },
    preCheck: function preCheck() {
      if (this.accountFlag == '1') {
        if (this.valueCheck(this.payeeName, '', '请填写收款人姓名')) {
          return true;
        }

        if (this.valueCheck(this.cxs, '', '请填写挂科市')) {
          return true;
        }
        if (this.valueCheck(this.cxx, '', '请填写挂科区/县')) {
          return true;
        }
        if (this.valueCheck(this.cxkcmc, '', '请填写挂科驾校名称')) {
          return true;
        }

        if (this.valueCheck(this.payeeCertNo, '', '请填写收款人身份证号')) {
          return true;
        }
        if (this.valueCheck(this.payeePhone, '', '请填写收款人电话')) {
          return true;
        }
        if (this.valueCheck(this.bankCode, '', '请填写银行账号')) {
          return true;
        }
        if (this.valueCheck(this.bankName, '', '请填写银行名称')) {
          return true;
        }
        if (this.valueCheck(this.bankProvinceName, '', '请填写银行所在省份')) {
          return true;
        }
        if (this.valueCheck(this.bankCityName, '', '请填写银行所在地市')) {
          return true;
        }
        if (this.valueCheck(this.bankSubName, '', '请填写开户支行')) {
          return true;
        }
        if (this.valueCheck(this.signUrl, '', '请手写签名')) {
          return true;
        }
      }
      if (this.valueCheck(this.selCurrentDate, '请选择挂科日期', '请选择挂科日期')) {
        return true;
      }
      if (this.valueCheck(this.position, '请选择挂科地区', '请选择挂科地区')) {
        return true;
      }
      if (this.valueCheck(this.jxPosition, '请选择驾校所在地', '请选择驾校所在地')) {
        return true;
      }
      if (this.valueCheck(this.claimClass, '请选择补偿科目', '请选择补偿科目')) {
        return true;
      }
      if (this.valueCheck(this.result, '请选择考试结果', '请选择考试结果')) {
        return true;
      }
      if (this.valueCheck(this.score, '', '请填写考试成绩')) {
        return true;
      }
      if (this.valueCheck(this.claimFee, '0', '补偿金额为0，不可补偿')) {
        return true;
      }
      if (this.valueCheck(this.password122, '', '交管12123密码')) {
        return true;
      }
      return false;
    },
    submit: function submit() {

      if (this.autoFee == '0') {
        this.$refs.popupShows.popupShowing('请选择是否自动截图！');
        return;
      }

      if (this.preCheck()) {
        return;
      }

      if (this.autoFee == '2') {
        if (this.stuInfoUrl.length == 0 || this.stuInfoUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传学员信息页！');
          return;
        }
        if (this.testScoreUrl.length == 0 || this.testScoreUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试成绩页！');
          return;
        }
        if (this.firstDetailUrl.length == 0 || this.firstDetailUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传首次科目一预约详情页！');
          return;
        }
        if (this.incidentSubjectUrl.length == 0 || this.incidentSubjectUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传挂科科目预约详情页！');
          return;
        }
        if (this.testFeeUrl.length == 0 || this.testFeeUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试费已缴纳页！');
          return;
        }
        if (this.waitTestFeeUrl.length == 0 || this.waitTestFeeUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试费待缴纳页！');
          return;
        }
      }
      if (this.fileListFront.length == 0 || this.fileListBack.length == 0) {
        this.$refs.popupShows.popupShowing('请先上传证件照！');
        return;
      }
      if (!this.checked) {
        this.$refs.popupShows.popupShowing('请先同意授权！');
        return;
      }
      if (!this.signUrl || this.signUrl == '') {
        this.$refs.popupShows.popupShowing('请完成手写签名');
        return;
      }
      var self = this;

      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "applets-server/api/policy/save";
      this.$refs.loading.loadingFlag = true;
      console.log("this.stuInfoUrl", this.stuInfoUrl);
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          claimAmount: this.claimFee,
          claimSubjectName: this.claimClass,
          claimSubjectNo: this.claimClassCode,
          examResultsName: this.result,
          examResultsNo: this.resultCode,
          examScore: this.score,
          policyAreaName: this.position,
          policyAreaNo: this.positionCode,
          policyTime: this.selCurrentDate,
          schoolAreaName: this.jxPosition,
          schoolAreaNo: this.jxPositionCode,
          password122: this.password122,
          token: localStorage.getItem('infoToken'),
          payeeName: this.payeeName,
          payeeCertNo: this.payeeCertNo,
          payeePhone: this.payeePhone,
          bankCode: this.bankCode,
          bankName: this.bankName,
          bankProvinceName: this.bankProvinceName,
          bankCityName: this.bankCityName,
          bankSubName: this.bankSubName,
          certFile: this.fileListFront[0].img + '|' + this.fileListBack[0].img,
          positiveImage: this.fileListFront[0].img,
          negativeImage: this.fileListBack[0].img,
          signUrl: this.signUrl,
          cxx: this.cxx,
          cxs: this.cxs,
          cxkcmc: this.cxkcmc,
          autoFee: this.autoFee,
          stuInfoUrl: this.stuInfoUrl.length > 0 ? this.stuInfoUrl[0].img : '',
          testScoreUrl: this.testScoreUrl.length > 0 ? this.testScoreUrl[0].img : '',
          firstDetailUrl: this.firstDetailUrl.length > 0 ? this.firstDetailUrl[0].img : '',
          incidentSubjectUrl: this.incidentSubjectUrl.length > 0 ? this.incidentSubjectUrl[0].img : '',
          testFeeUrl: this.testFeeUrl.length > 0 ? this.testFeeUrl[0].img : '',
          waitTestFeeUrl: this.waitTestFeeUrl.length > 0 ? this.waitTestFeeUrl[0].img : ''
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {
          var bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
          bdOrderInfo.claimClassCode = self.claimClassCode;
          bdOrderInfo.policyId = data.data;
          bdOrderInfo.policyTime = self.selCurrentDate;
          localStorage.setItem('bdOrderInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bdOrderInfo));
          if (self.autoFee == '1') {

            setTimeout(function () {
              self.$router.push('/login');
            }, 1000);
          } else {
            self.$refs.popupShows.popupShowing('提交成功!!!!!');
            self.openBtn = false;
          }
        } else {
          self.$refs.popupShows.popupShowing(data.errorMessage);
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.ajaxState = true;
        self.$refs.loading.loadingFlag = false;
        self.$refs.popupShows.popupShowing('网络异常，请重试！');
      });
    },
    init: function init() {
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "applets-server/api/policy/init";
      this.$refs.loading.loadingFlag = true;
      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          token: localStorage.getItem('infoToken')
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        var data = res.data;
        if (data.success) {
          self.userName = data.data.userName || '';
          self.provinceListInit = data.data.provinceList || [];
          self.subjectListInit = data.data.subjectList || [];
          self.resultListInit = data.data.resultList || [];
          for (var p in self.provinceListInit) {
            self.provinceList.push(self.provinceListInit[p].areaName);
          }
          for (var s in self.subjectListInit) {
            self.claimClassList.push(self.subjectListInit[s].subjectName);
          }
          for (var r in self.resultListInit) {
            self.resultList.push(self.resultListInit[r].resultName);
          }
          var policy = data.data.policy || {};
          self.claimFee = policy.claimAmount || '';
          self.claimClass = policy.claimSubjectName || '请选择补偿科目';
          self.claimClassCode = policy.claimSubjectNo || '';
          self.result = '未通过';
          self.resultCode = '2';
          self.score = policy.examScore || '';
          self.position = policy.policyAreaName || '请选择挂科地区';
          self.positionCode = policy.policyAreaNo || '';
          self.selCurrentDate = policy.policyTime || '请选择挂科日期';

          self.password122 = policy.password122 || '';
          self.payeeName = policy.payeeName || '';
          self.payeeCertNo = policy.payeeCertNo || '';
          self.payeePhone = policy.payeePhone || '';
          self.bankCode = policy.bankCode || '';
          self.bankName = policy.bankName || '';
          self.bankProvinceName = policy.bankProvinceName || '';
          self.bankCityName = policy.bankCityName || '';
          self.bankSubName = policy.bankSubName || '';
          self.initFlag = true;
          if (policy.positiveImage) {
            self.fileListFront = [{
              url: policy.positiveImage,
              img: policy.positiveImage
            }];
          }
          if (policy.negativeImage) {
            self.fileListBack = [{
              url: policy.negativeImage,
              img: policy.negativeImage
            }];
          }
          self.accountFlag = data.data.accountFlag || '0';
          if (self.accountFlag == '1') {
            self.activeNames = ['1', '2'];
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_12_vant_es_dialog__["a" /* default */].alert({
            showConfirmButton: false,
            message: data.errorMessage
          }).then(function () {});
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.$refs.loading.loadingFlag = false;
      });
    },
    getClaimFee: function getClaimFee() {
      var that = this;
      if (that.positionCode && that.claimClassCode) {
        var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "/applets-server/api/policy/claim/amount";
        this.$ajax({
          method: "get",
          url: url,
          withCredentials: false,
          params: {
            areaCode: that.positionCode,
            token: localStorage.getItem('infoToken')
          },
          headers: { 'Content-Type': 'application/json' }
        }).then(function (res) {
          var data = res.data;
          if (data.success && data.data) {
            var resData = data.data;
            if (that.claimClassCode == '01' && resData.subjectOneAmount != '0') {
              that.claimFee = resData.subjectOneAmount;
            } else if (that.claimClassCode == '02' && resData.subjectTwoAmount != '0') {
              that.claimFee = resData.subjectTwoAmount;
            } else if (that.claimClassCode == '03' && resData.subjectThreeAmount != '0') {
              that.claimFee = resData.subjectThreeAmount;
            } else if (that.claimClassCode == '04' && resData.subjectFourAmount != '0') {
              that.claimFee = resData.subjectFourAmount;
            } else {
              that.$refs.popupShows.popupShowing('对不起，暂不支持补偿！');
            }
          } else {
            that.$refs.popupShows.popupShowing(data.errorMessage);
          }
        }).catch(function (err) {
          that.$refs.popupShows.popupShowing('网络异常，请重试！');
        });
      }
    },
    openProtocol: function openProtocol() {
      this.$refs.maskShow.maskFlag = true;
      this.protocolDetailFlag = true;
    },
    closeProtocol: function closeProtocol() {
      this.$refs.maskShow.maskFlag = false;
      this.protocolDetailFlag = false;
    },
    selBankList: function selBankList(item) {
      this.bankName = item.bankName;
      this.bankListFlag = false;
    },
    querySubBank: function querySubBank(bankSubName) {
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "applets-server/api/policy/bankQuery";
      this.loading = true;
      this.$ajax({
        method: "post",
        url: url,
        data: {
          bankCode: this.bankCode,
          bankName: this.bankName,
          bankCityName: this.bankCityName,
          bankProvinceName: this.bankProvinceName,
          bankSubName: bankSubName
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        var data = res.data;
        if (data.success) {
          self.subBankList = data.data;
          self.loading = false;
        } else {
          self.subBankList = [];
          self.loading = false;
        }
      }).catch(function (err) {
        console.log(err);
        self.loading = false;
      });
    }
  },
  watch: {
    bankCode: function bankCode() {
      if (this.initFlag) {
        this.initFlag = false;
        return;
      }
      if (this.bankCode.length < 12) {
        return;
      }
      var that = this;
      that.bankName = '';
      that.bankListFlag = false;
      var url = __WEBPACK_IMPORTED_MODULE_23__common_api__["a" /* Config */].api_url + "applets-server/api/bank/name";
      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          bankCode: this.bankCode,
          token: localStorage.getItem('infoToken')
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        var data = res.data;
        if (data.success && data.data) {
          var resData = data.data;
          that.bankName = resData.bankName;
        } else {}
      }).catch(function (err) {});
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_button_style__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_button__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orderQuery_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orderQuery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orderQuery_vue__);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_button__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: "learn",
    data: function data() {
        return {
            video: {}
        };
    },

    methods: {
        orderQuery: function orderQuery() {
            window.history.back();
        }
    }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_image_style__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_image__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast_style__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_tag_style__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_tag__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_cell_style__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_cell__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_button_style__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_es_button__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant_es_field_style__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_es_field__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vant_es_form_style__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_es_form__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vant_es_popup_style__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vant_es_popup__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vant_es_picker_style__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vant_es_picker__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sign_signer_jj__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sign_signer_jj___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__sign_signer_jj__);
























__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vant_es_picker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vant_es_popup__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vant_es_form__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vant_es_field__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vant_es_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vant_es_cell__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant_es_tag__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_18_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_image__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myInfo',
  props: {
    certNo: null
  },
  components: {
    signer: __WEBPACK_IMPORTED_MODULE_20__sign_signer_jj___default.a
  },
  data: function data() {
    return {
      isDict: 0,
      dataList: [],
      loading: true,
      openForm: false,
      sysDictList: [],
      claimId: '',
      checked: false,
      jjType: '',
      jjje: 0.00,
      jjbj: '',
      jjid: '',
      showPicker: false,
      isPhone: true,
      signShow: false,
      paymentType: '',
      userName: '',
      cerId: '',
      claimMoney: 0.00,
      signUrl: '',
      paymentUrl: '',
      paymentTypeOpen: false,
      openImg: false,
      openImgTitle: '',
      paymentValue: ''
    };
  },
  mounted: function mounted() {
    this.initInfo();
    this.getSysDict();

    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;
    var userAgent = navigator.userAgent;
    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备");
    } else {
      console.log("这是PC端");
      this.isPhone = false;
    }
  },

  methods: {
    saveInfo: function saveInfo() {
      if (this.jjType == null || this.jjType == '') {
        __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */].fail('请选择加急方式!');
        return;
      }
      if (this.signUrl == null || this.signUrl == '') {
        __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */].fail('请签名!');
        return;
      }
      if (this.paymentType == null || this.paymentType == '') {
        __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */].fail('请选择支付方式!');
        return;
      }
      var self = this;
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_19__common_api__["a" /* Config */].api_url + "applets-server/api/payment/save",
        withCredentials: false,
        data: {
          money: self.jjje,
          claimId: self.claimId,
          type: self.paymentType,
          userName: self.userName,
          cerId: self.cerId,
          jjId: self.jjid,
          signUrl: self.signUrl

        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        if (res.data.success == true) {
          self.paymentUrl = res.data.data;
          console.log(self.paymentUrl);
          self.closePop();
          self.openImg = true;
        } else {}
      });
    },
    openProtocol: function openProtocol() {},
    readBook: function readBook(val) {
      if (val) {
        this.gotoSign();
      }
    },
    gotoSign: function gotoSign() {
      this.signShow = true;
    },
    setSign: function setSign(signUrl) {
      this.signUrl = signUrl;
      this.signShow = false;
    },
    onConfirm: function onConfirm(value, index) {
      console.log("value", value);
      this.jjType = value.dictName;
      this.jjbj = value.dictValue;
      this.jjid = value.id;
      this.jjje = this.claimMoney * 1.00 * (parseFloat(value.dictValue) * 1.00 / 100);
      this.showPicker = false;
    },
    paymentBtn: function paymentBtn(v) {
      this.paymentType = v.value;
      this.paymentValue = v.name;
      this.openImgTitle = v.name;
      this.paymentTypeOpen = false;
    },
    initInfo: function initInfo() {
      var self = this;
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_19__common_api__["a" /* Config */].api_url + "applets-server/api/policy/myInfo",
        withCredentials: false,
        params: {
          certId: this.certNo
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.dataList = res.data.data;
        self.loading = false;
      });
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_19__common_api__["a" /* Config */].api_url + "applets-server/api/dict/getDict",
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        self.isDict = res.data.data;
        console.log("self.isDict", self.isDict);
      });
    },
    getSysDict: function getSysDict() {
      var self = this;
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_19__common_api__["a" /* Config */].api_url + "applets-server/api/dict/getDictList",
        withCredentials: false,
        params: {
          certId: this.certNo
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.sysDictList = res.data.data;
      });
    },
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var day = ('0' + date.getDate()).slice(-2);
      var hours = ('0' + date.getHours()).slice(-2);
      var minutes = ('0' + date.getMinutes()).slice(-2);
      var seconds = ('0' + date.getSeconds()).slice(-2);
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
    openFormEvent: function openFormEvent(item) {
      console.log(item);
      this.claimId = item.CLAIM_ID;
      this.cerId = item.CERT_ID;
      this.userName = item.NAME;
      this.claimMoney = parseFloat(item.CLAIM_FEE);
      this.closePop();
      this.openForm = true;
    },
    closePop: function closePop() {
      this.jjType = '';
      this.jjje = 0.00;
      this.jjbj = '';
      this.jjid = '';
      this.showPicker = false;
      this.openForm = false;
      this.checked = false;
      this.signUrl = "";
      this.paymentValue = "";
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_order_myInfo__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_order_myInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_order_myInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "myOrderInfo",
  data: function data() {
    return {
      certNo: '',
      isShow: false
    };
  },

  components: {
    myInfo: __WEBPACK_IMPORTED_MODULE_0__components_order_myInfo___default.a
  },
  mounted: function mounted() {
    var c_Id = this.$route.params.credId;
    this.certNo = c_Id;
    this.isShow = true;
    console.log("c_Id", c_Id);
  },

  methods: {
    goPage: function goPage() {
      this.$router.push('/settlementInfo/' + this.certNo);
    }
  }

});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_dropdown_item_style__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_dropdown_item__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_dropdown_menu_style__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_dropdown_menu__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_button_style__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_button__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_search_style__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_search__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_order_myInfo__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_order_myInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_order_myInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_reset_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__common_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_common__ = __webpack_require__(35);





















__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vant_es_search__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vant_es_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vant_es_dropdown_menu__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vant_es_dropdown_item__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "query",
  data: function data() {
    return {
      ajaxState: true,
      certNo: '',
      showFlag: true,
      showOrder: true,
      userInfo: {},
      errorMessage: '',
      searchBank: '',
      showDropdown: false,
      subBankList: [],
      searchText: ''
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup___default.a,
    myInfo: __WEBPACK_IMPORTED_MODULE_13__components_order_myInfo___default.a,
    ajaxLoading: __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading___default.a,
    maskPopup: __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv___default.a
  },
  mounted: function mounted() {
    document.title = '订单查询';
  },

  methods: {
    handleSearch: function handleSearch(bankSubName) {
      if (!bankSubName || bankSubName.length < 2) {
        this.showDropdown = false;
        return;
      }
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_14__common_api__["a" /* Config */].api_url + "applets-server/api/policy/bankQuery";

      this.$ajax({
        method: "post",
        url: url,
        data: {
          bankCode: this.bankCode,
          bankName: this.bankName,
          bankCityName: this.bankCityName,
          bankProvinceName: this.bankProvinceName,
          bankSubName: bankSubName
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        var data = res.data;
        if (data.success) {
          self.subBankList = data.data.map(function (itm) {
            return { text: itm };
          });
          self.showDropdown = true;
        } else {
          self.subBankList = [{ text: '无数据' }];
          self.showDropdown = true;
        }
      }).catch(function (err) {
        console.log(err);
        self.showDropdown = false;
      });
    },

    checkIdCard: function checkIdCard(id) {
      if (this.checkScript(id)) {
        this.$refs.popupShows.popupShowing("证件号码包含非法字符");
        return false;
      } else if (!this.idCheck(id)) {
        this.$refs.popupShows.popupShowing("请输入正确的身份证号");
        return false;
      }

      return true;
    },
    queryOrder: function queryOrder() {
      var self = this;
      if (!this.checkIdCard(this.certNo)) {
        return;
      }
      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      var url = __WEBPACK_IMPORTED_MODULE_14__common_api__["a" /* Config */].api_url + "applets-server/api/policy/order/query";
      this.$refs.loading.loadingFlag = true;

      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          certId: this.certNo
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {
          self.userInfo = data.data;
          self.errorMessage = data.data.errorMessage || '';
          localStorage.setItem('infoToken', data.data.token);
          localStorage.setItem('bdOrderInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data));
          self.$router.push('/myOrder/' + self.certNo);
        } else {
          self.$refs.popupShows.popupShowing(data.errorMessage);
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.ajaxState = true;
        self.$refs.loading.loadingFlag = false;
        self.$refs.popupShows.popupShowing('网络异常，请重试！');
      });
    },
    toClaim: function toClaim() {
      if (this.errorMessage) {
        this.$refs.popupShows.popupShowing(this.errorMessage);
        return;
      }
      this.$router.push('/applyClaim');
    }
  },
  watch: {}
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_dropdown_item_style__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_dropdown_item__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_dropdown_menu_style__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_dropdown_menu__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_button_style__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vant_es_button__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vant_es_search_style__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vant_es_search__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_reset_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_common__ = __webpack_require__(35);



















__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vant_es_search__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vant_es_button__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vant_es_dropdown_menu__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vant_es_dropdown_item__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementInfo",
  data: function data() {
    return {
      ajaxState: true,
      certNo: '',
      showFlag: true,
      showOrder: true,
      userInfo: {},
      errorMessage: '',
      searchBank: '',
      showDropdown: false,
      subBankList: [],
      searchText: ''
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_10__common_commonComponents_popup___default.a,
    ajaxLoading: __WEBPACK_IMPORTED_MODULE_11__common_commonComponents_loading___default.a,
    maskPopup: __WEBPACK_IMPORTED_MODULE_12__common_commonComponents_maskDiv___default.a
  },
  mounted: function mounted() {
    document.title = '订单查询';
    var c_Id = this.$route.params.credId;
    this.certNo = c_Id;
    this.queryOrder();
    console.log("c_Id", c_Id);
  },

  methods: {
    handleSearch: function handleSearch(bankSubName) {
      if (!bankSubName || bankSubName.length < 2) {
        this.showDropdown = false;
        return;
      }
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_13__common_api__["a" /* Config */].api_url + "applets-server/api/policy/bankQuery";

      this.$ajax({
        method: "post",
        url: url,
        data: {
          bankCode: this.bankCode,
          bankName: this.bankName,
          bankCityName: this.bankCityName,
          bankProvinceName: this.bankProvinceName,
          bankSubName: bankSubName
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        var data = res.data;
        if (data.success) {
          self.subBankList = data.data.map(function (itm) {
            return { text: itm };
          });
          self.showDropdown = true;
        } else {
          self.subBankList = [{ text: '无数据' }];
          self.showDropdown = true;
        }
      }).catch(function (err) {
        console.log(err);
        self.showDropdown = false;
      });
    },

    checkIdCard: function checkIdCard(id) {
      if (this.checkScript(id)) {
        this.$refs.popupShows.popupShowing("证件号码包含非法字符");
        return false;
      } else if (!this.idCheck(id)) {
        this.$refs.popupShows.popupShowing("请输入正确的身份证号");
        return false;
      }

      return true;
    },
    queryOrder: function queryOrder() {
      var self = this;
      if (!this.checkIdCard(this.certNo)) {
        return;
      }
      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      var url = __WEBPACK_IMPORTED_MODULE_13__common_api__["a" /* Config */].api_url + "applets-server/api/policy/order/query";
      this.$refs.loading.loadingFlag = true;

      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          certId: this.certNo
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {
          self.showFlag = false;
          self.userInfo = data.data;
          self.errorMessage = data.data.errorMessage || '';
          localStorage.setItem('infoToken', data.data.token);
          localStorage.setItem('bdOrderInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.data));
        } else {
          self.$refs.popupShows.popupShowing(data.errorMessage);
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.ajaxState = true;
        self.$refs.loading.loadingFlag = false;
        self.$refs.popupShows.popupShowing('网络异常，请重试！');
      });
    },
    toClaim: function toClaim() {
      if (this.errorMessage) {
        this.$refs.popupShows.popupShowing(this.errorMessage);
        return;
      }
      this.$router.push('/applyClaim');
    },
    goPage: function goPage() {
      this.$router.push('/myOrder/' + this.certNo);
    }
  },
  watch: {}
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_signature__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smooth_signature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "signer",

  data: function data() {
    return {
      showFull: false,
      isPhone: true,
      signature1: null
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var userAgent = navigator.userAgent;

    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;

    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备");
      this.initSignture2();
    } else {
      console.log("这是PC端");
      this.isPhone = false;
      this.$nextTick(function () {
        _this.initSignature1();
      });
    }
  },

  methods: {
    initSignature1: function initSignature1() {
      var canvas = this.$refs["canvas1"];
      var options = {
        width: 800,
        height: 400,
        minWidth: 2,
        maxWidth: 6,
        openSmooth: true
      };
      this.signature1 = new __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default.a(canvas, options);
    },
    initSignture2: function initSignture2() {
      var canvas = this.$refs["canvas2"];
      var options = {
        width: window.innerWidth - 80,
        height: window.innerHeight - 180,
        minWidth: 3,
        maxWidth: 10,
        openSmooth: true
      };
      this.signature2 = new __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default.a(canvas, options);
    },
    handleClear1: function handleClear1() {
      this.signature1.clear();
    },
    handleClear2: function handleClear2() {
      this.signature2.clear();
    },
    handleUndo1: function handleUndo1() {
      this.signature1.undo();
    },
    handleUndo2: function handleUndo2() {
      this.signature2.undo();
    },
    handleFull: function handleFull() {
      this.showFull = !this.showFull;
    },
    handlePreview1: function handlePreview1() {
      var isEmpty = this.signature1.isEmpty();
      if (isEmpty) {
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      var canvas = this.signature1.getRotateCanvas();
      var pngUrl = canvas.toDataURL();

      this.$emit('set-sign', pngUrl);
    },
    handlePreview2: function handlePreview2() {
      var isEmpty = this.signature2.isEmpty();
      if (isEmpty) {
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      var canvas = this.signature2.getRotateCanvas(-90);
      var pngUrl = canvas.toDataURL();

      this.$emit('set-sign', pngUrl);
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_signature__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smooth_signature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "signer_jj",

  data: function data() {
    return {
      showFull: false,
      isPhone: true,
      signature1: null
    };
  },

  components: {
    popup: __WEBPACK_IMPORTED_MODULE_1__common_commonComponents_popup___default.a
  },
  mounted: function mounted() {
    var _this = this;

    var userAgent = navigator.userAgent;

    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;

    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备");
      this.initSignture2();
    } else {
      console.log("这是PC端");
      this.isPhone = false;
      this.$nextTick(function () {
        _this.initSignature1();
      });
    }
  },

  methods: {
    initSignature1: function initSignature1() {
      var canvas = this.$refs["canvas1"];
      var options = {
        width: 800,
        height: 400,
        minWidth: 2,
        maxWidth: 6,
        openSmooth: true
      };
      this.signature1 = new __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default.a(canvas, options);
    },
    initSignture2: function initSignture2() {
      var canvas = this.$refs["canvas2"];
      var options = {
        width: window.innerWidth - 80,
        height: window.innerHeight - 180,
        minWidth: 3,
        maxWidth: 10,
        openSmooth: true
      };
      this.signature2 = new __WEBPACK_IMPORTED_MODULE_0_smooth_signature___default.a(canvas, options);
    },
    handleClear1: function handleClear1() {
      this.signature1.clear();
    },
    handleClear2: function handleClear2() {
      this.signature2.clear();
    },
    handleUndo1: function handleUndo1() {
      this.signature1.undo();
    },
    handleUndo2: function handleUndo2() {
      this.signature2.undo();
    },
    handleFull: function handleFull() {
      this.showFull = !this.showFull;
    },
    handlePreview1: function handlePreview1() {
      var isEmpty = this.signature1.isEmpty();
      if (isEmpty) {
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      var canvas = this.signature1.getRotateCanvas();
      var pngUrl = canvas.toDataURL();

      this.$emit('set-sign', pngUrl);
    },
    handlePreview2: function handlePreview2() {
      var isEmpty = this.signature2.isEmpty();
      if (isEmpty) {
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      var canvas = this.signature2.getRotateCanvas(-90);
      var pngUrl = canvas.toDataURL();

      this.$emit('set-sign', pngUrl);
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "checkType",
  methods: {
    openXueyuan: function openXueyuan(type) {
      if (type == 0) {
        this.$router.push('/toubaoManager');
      } else {
        this.$router.push('/myOrders');
      }
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_api__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "login",
  data: function data() {
    return {
      userRole: '0',
      showModal: false,
      loading: false,
      phone: "",
      captcha: "",
      password: "",
      ajaxState: true,
      captchaAjaxState: true,
      isShow: false,
      buttonText: "获取验证码",
      showImg: 1,
      count: 60,
      agreeState: false,
      captchaUrl: '',
      ticket: '',
      showPasswordFlag: false,
      loginType: '1',
      errorText: '',
      token: '',
      imgCaptcha: '',
      codeKey: '',
      username: '' };
  },
  mounted: function mounted() {
    this.resize();
    document.getElementsByTagName('title')[0].innerText = '登录';
    this.userRole = this.$route.query.role || '0';
    this.getImgCaptcha();
  },

  methods: {
    onEnter: function onEnter() {
      this.submit();
    },
    resize: function resize() {
      var _width = this.getPageWidth();
      var ratio = _width / 1980;
      var curWidth = 16 * ratio;
      document.getElementsByTagName('html')[0].style.fontSize = curWidth + "px";
    },
    getPageWidth: function getPageWidth() {
      var g = document,
          a = g.body,
          f = g.documentElement,
          d = g.compatMode == "BackCompat" ? a : g.documentElement;
      return Math.max(f.scrollWidth, a.scrollWidth, d.clientWidth);
    },
    toAgree: function toAgree() {
      this.agreeState = !this.agreeState;
    },
    checkMobiles: function checkMobiles(number) {
      return (/^((13|15|18|14|17|16|19)+\d{9})$/.test(number)
      );
    },
    checkPhone: function checkPhone(number) {
      if (number.trim() === "") {
        this.$message({
          type: "error",
          message: '请填写手机号码',
          offset: 300
        });
        return false;
      } else if (!this.checkMobiles(number)) {
        this.$message({
          type: "error",
          message: '您的手机号码格式有误，请重新输入',
          offset: 300
        });
        return false;
      }
      return true;
    },
    sendMessage: function sendMessage() {
      if (!this.checkPhone(this.phone)) {
        return;
      }
      var self = this;
      if (this.captchaAjaxState) {
        this.captchaAjaxState = false;
        this.$ajax({
          method: "post",
          url: __WEBPACK_IMPORTED_MODULE_2__components_common_api__["a" /* Config */].api_url + "user/message/send",
          params: {
            MESSAGE_PARAM: { "PHONE_NUMBER": this.phone }
          }
        }).then(function (res) {
          var data = res.data;
          if (data.CODE === '0000') {
            var count = 60;
            var setYzm = setInterval(function () {
              if (count === 0) {
                clearInterval(setYzm);
                self.buttonText = "重新获取";
                count = 60;
                self.captchaAjaxState = true;
              } else {
                self.buttonText = count + "s后重新获取";
                count -= 1;
              }
            }, 1000);
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 300
            });
            self.captchaAjaxState = true;
          }
        }).catch(function (err) {
          self.$message({
            type: "error",
            message: '网络异常，请重试',
            offset: 300
          });
          self.captchaAjaxState = true;
        });
      }
    },
    getImgCaptcha: function getImgCaptcha() {
      var self = this;
      if (this.captchaAjaxState) {
        this.captchaAjaxState = false;
        this.$ajax({
          method: "get",
          url: __WEBPACK_IMPORTED_MODULE_2__components_common_api__["a" /* Config */].api_url + "applets-server/api/image/captcha",
          params: {}
        }).then(function (res) {
          self.captchaAjaxState = true;
          var data = res.data;
          if (data.success) {
            self.imgCaptcha = data.data.image;
            self.codeKey = data.data.codeKey;
          } else {
            self.$message({
              type: "error",
              message: data.errorMessage,
              offset: 300
            });
          }
        }).catch(function (err) {
          self.$message({
            type: "error",
            message: '网络异常，请重试',
            offset: 300
          });
          self.captchaAjaxState = true;
        });
      }
    },
    submit: function submit() {
      var self = this;
      if (this.username == '') {
        this.$message({
          type: "error",
          message: '请正确填写账号',
          offset: 300
        });
        return false;
      }
      if (this.captcha == '') {
        this.$message({
          type: "error",
          message: '请正确填写验证码',
          offset: 300
        });
        return false;
      }

      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      var url = __WEBPACK_IMPORTED_MODULE_2__components_common_api__["a" /* Config */].api_url + "applets-server/api/login/account";

      var param = {
        type: 'account',
        username: this.username,
        codeVal: this.captcha,
        codeKey: this.codeKey
      };
      if (this.loginType === '0') {
        param.CAPTCHA = this.captcha;
      } else {
        param.password = this.password;
      }
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, param),
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {
          self.$message({
            type: "success",
            message: '登录成功',
            offset: 300,
            duration: 2000
          });
          var userInfo = {
            name: data.data.name,
            currentAuthority: data.data.currentAuthority,
            type: "account",
            insuredId: data.data.insuredId
          };
          localStorage.setItem('localUserInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userInfo));
          localStorage.setItem('token', data.data.accessToken);
          localStorage.setItem('needReload', '1');
          setTimeout(function () {
            self.$router.push('/checkType');
          }, 1000);
        } else {
          self.getImgCaptcha();
          self.$message({
            type: "error",
            message: data.errorMessage,
            offset: 300
          });
        }
      }).catch(function (err) {
        self.$message({
          type: "error",
          message: '网络异常，请重试',
          offset: 300
        });
        self.ajaxState = true;

        self.getImgCaptcha();
      });
    },
    toRule: function toRule(type) {
      this.$router.push("/rule?type=" + type);
    },
    toRegister: function toRegister() {
      this.$router.push('register');
    }
  },
  watch: {
    phone: function phone() {
      this.phone = this.phone.replace(/[^0-9]+/, '');
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_api__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "myOrders",
  data: function data() {
    return {
      openShow: false,
      order: null,
      list: [],
      loading: false,
      finished: false,
      searchValue: {
        certId: "",
        name: "",
        orderState: "",
        payState: "",
        insuranceNo: "",
        contactNumber: "",
        currPage: 0,
        productName: "",
        pageSize: 20
      },
      total: 0,
      imagesUrl: []
    };
  },
  mounted: function mounted() {},

  methods: {
    openShowInfo: function openShowInfo(item) {

      this.initData(item);
    },
    initData: function initData(item) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, res;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$ajax({
                  method: "get",
                  url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/order/detail/" + item.orderId,
                  headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
                });

              case 2:
                _ref = _context.sent;
                res = _ref.data;

                if (res.success) {
                  _this.openShow = true;
                  _this.order = res.data;

                  if (_this.order.positiveImage !== '') {
                    _this.imagesUrl.push(res.data.positiveImage);
                  }

                  if (_this.order.negativeImage !== '') {
                    _this.imagesUrl.push(res.data.negativeImage);
                  }
                  if (_this.order.payImage !== '') {
                    _this.imagesUrl.push(res.data.payImage);
                  }
                } else {
                  _this.$message.error(res.errorMessage);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    queryList: function queryList() {
      this.searchValue.currPage = 0;
      this.list = [];
      this.onLoad();
    },
    onLoad: function onLoad() {
      this.searchValue.currPage = this.searchValue.currPage + 1;
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/order/list";
      this.$ajax({
        method: "get",
        url: url,
        params: {
          current: self.searchValue.currPage,
          pageSize: self.searchValue.pageSize,
          contactNumber: self.searchValue.contactNumber,
          certId: self.searchValue.certId,
          name: self.searchValue.name,
          startTime: self.searchValue.startTime,
          endTime: self.searchValue.endTime,
          orderState: self.searchValue.orderState,
          payState: self.searchValue.payState,
          insuranceNo: self.searchValue.insuranceNo,
          productName: self.searchValue.productName
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: localStorage.getItem("token")
        }
      }).then(function (res) {
        var data = res.data;
        if (data.data && data.success) {
          console.log("self.loading1", data.data);
          self.list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(self.list), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.data));
          self.total = data.total;

          self.loading = false;
          console.log("self.loading", self.list);

          if (self.list.length >= self.total) {
            self.finished = true;
          }
        } else {
          self.$message({
            type: "error",
            message: data.errorMessage,
            offset: 200
          });
        }
      }).catch(function (err) {
        self.$message({
          type: "error",
          message: "网络异常，请重试！",
          offset: 200
        });
      });
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_api__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "toubaoManager",
  data: function data() {
    return {
      loading: true,
      dataList: []
    };
  },
  mounted: function mounted() {
    this.initTable();
  },

  methods: {
    initTable: function initTable() {
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_0__components_common_api__["a" /* Config */].api_url + "applets-server/api/product/list";
      this.$ajax({
        method: "get",
        url: url,
        params: {
          current: 1,
          pageSize: 10000,
          insuranceCompanyId: '',
          productState: 1,
          productName: '',
          productProvince: ''
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var data = res.data;
        if (data.data) {
          self.dataList = data.data || [];
          self.loading = false;
        } else {
          self.$message({
            type: "error",
            message: data.errorMessage,
            offset: 200
          });
        }
        self.loading = false;
      }).catch(function (err) {
        self.$message({
          type: "error",
          message: '网络异常，请重试！',
          offset: 200
        });
      });
    },
    toubaoViewOpen: function toubaoViewOpen(item) {
      this.$router.push("/toubaoView?productId=" + item.productId);
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast_style__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "toubaoView",
  components: {
    tbxz: __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue___default.a, fwxy: __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue___default.a, khgzs: __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue___default.a
  },
  data: function data() {
    return {
      fileListFront: [],
      fileListBack: [],
      getStatusTemp: null,
      hasData: false,
      agreeState: false,
      paymentTitle: '微信支付',
      studentList: [{
        name: '',
        cardId: '',
        mobile: ''
      }],
      downloadFile: '',
      fileList: [],
      singleFee: 0,
      totalFee: '0.00',
      payDialogVisible: false,
      fileListPay: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      headers: {},
      uploadUrl: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/minio/upload/niu.pay',
      dialogVisiblePay: false,
      dialogVisibleProtocol: false,
      payImgUrlList: [],
      productId: '',
      productName: '',
      dsName: '',
      dsSocialCode: '',
      ruleTypes: 1,
      loading: true
    };
  },
  mounted: function mounted() {
    var query = this.$route.query;
    if (query.token) {
      localStorage.setItem("token", query.token);
    }
    this.headers = { 'Authorization': localStorage.getItem('token') };
    this.productId = this.$route.query.productId || '0';
    this.init();
  },

  methods: {
    deletePhoto: function deletePhoto(file, type) {
      var url = __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/minio/remove/cert";
      var that = this;
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          fileName: file.img
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {} else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
        }
      }).catch(function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('网络异常，请重试！');
      });
    },
    beforeRead: function beforeRead(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.resizeCount = 1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('图片大小不能超过10M');
        return false;
      }
      return true;
    },
    afterRead: function afterRead(file, type) {
      var _this = this;

      console.log(file);
      var url = __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/minio/upload/cert/image';
      var that = this;
      var config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      var formdata = new FormData();
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var img = new Image();
      img.src = file.content;
      console.log('0', file.content.length / 1024);
      var imageSize = file.content.length || 100;
      if (imageSize <= 10 * 1024 * 1024 && imageSize > 8 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 8 * 1024 * 1024 && imageSize > 6 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 6 * 1024 * 1024 && imageSize > 4 * 1024 * 1024) {
        this.resizeCount = 2.5;
      } else if (imageSize <= 4 * 1024 * 1024 && imageSize > 2 * 1024 * 1024) {
        this.resizeCount = 1.5;
      } else {
        this.resizeCount = 1;
      }
      console.log(this.resizeCount);
      img.onload = function () {
        if (_this.resizeCount > 1) {
          canvas.width = img.width / _this.resizeCount;
          canvas.height = img.height / _this.resizeCount;
          context.drawImage(img, 0, 0, img.width / _this.resizeCount, img.height / _this.resizeCount);
          file.content = canvas.toDataURL(file.file.type, 1);
        }
        var files = _this.dataURLtoFile(file.content, file.file.name);
        formdata.append('file', files);
        console.log('1', file.content.length / 1024);
        formdata.append('token', localStorage.getItem('infoToken'));
        _this.$ajax.post(url, formdata, config).then(function (res) {
          var data = res.data;
          if (data.success) {
            if (type == '1') {
              that.fileListFront[0].img = data.data;

              that.loading = true;
              that.$ajax({
                method: "post",
                url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/order/getIdCardInfo",
                data: {
                  url: that.fileListFront[0].img
                },
                headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
              }).then(function (res) {
                if (res.data.success && res.data.data != '' && res.data.data != null) {
                  that.studentList[0].name = res.data.data.name;
                  that.studentList[0].cardId = res.data.data.idNum;
                  that.loading = false;
                } else {
                  that.$message({
                    type: 'error',
                    message: "身份证识别失败！"
                  });
                  that.loading = false;
                }
              }).catch(function (e) {
                {
                  console.log(e);
                  that.loading = false;
                }
              });
            } else {
              that.fileListBack[0].img = data.data;
            }
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
            if (type == '1') {
              that.fileListFront = [];
            } else {
              that.fileListBack = [];
            }
          }
        }).catch(function (err) {
          if (type == '1') {
            that.fileListFront = [];
          } else {
            that.fileListBack = [];
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('网络异常，请重试！');
        });
      };
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    init: function init() {
      var that = this;
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + ("applets-server/api/policyPc/init/" + this.productId),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          var productMap = resData.data.productMap || {};
          that.downloadFile = productMap.templateUrl || '';
          that.singleFee = productMap.productFee || 0;
          that.totalFee = that.singleFee;
          that.payImgUrlList = (productMap.payUrl || '').split(',');
          that.productName = productMap.productName || '';
          var schoolMap = resData.data.schoolMap || {};
          that.dsName = schoolMap.dsName || '';
          that.dsSocialCode = schoolMap.dsSocialCode || '';


          that.loading = false;
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    toAgree: function toAgree() {
      this.agreeState = !this.agreeState;
    },
    toRule: function toRule(type) {
      this.dialogVisibleProtocol = true;
      this.ruleTypes = type;
    },
    delStudent: function delStudent(index) {
      this.studentList.splice(index, 1);
    },
    addStudent: function addStudent() {
      var newStu = {
        name: '',
        cardId: '',
        mobile: ''
      };
      this.studentList.push(newStu);
    },
    beforeUpload: function beforeUpload(file) {
      var _this2 = this;

      var that = this;
      var _file = file;
      var fileReader = new FileReader();
      fileReader.onload = function (ev) {
        try {
          var data = ev.target.result;
          var workbook = XLSX.read(data, {
            type: 'binary'
          });
          for (var sheet in workbook.Sheets) {
            var sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);

            if (sheetArray.length == 0) {
              continue;
            }

            for (var stu in sheetArray) {
              var thisStu = sheetArray[stu];

              var newStu = {
                name: thisStu['姓名'],
                cardId: thisStu['身份证'],
                mobile: thisStu['手机号']
              };
              that.studentList.push(newStu);
            }
          }
        } catch (e) {
          _this2.$message.warning('文件类型不正确！');
        }
      };
      fileReader.readAsBinaryString(_file);
    },
    checkMobiles: function checkMobiles(number) {
      return (/^((1)+\d{10})$/.test(number)
      );
    },
    checkData: function checkData() {
      var that = this;
      if (this.fileListFront == [] || this.fileListBack.length == 0) {
        that.$message({
          type: "error",
          message: "\u8EAB\u4EFD\u8BC1\u6B63\u9762\u7167\u4E0D\u80FD\u4E3A\u7A7A",
          offset: 300
        });
        return false;
      }
      if (this.fileListBack == [] || this.fileListBack.length == 0) {
        that.$message({
          type: "error",
          message: "\u8EAB\u4EFD\u8BC1\u53CD\u9762\u7167\u4E0D\u80FD\u4E3A\u7A7A",
          offset: 300
        });
        return false;
      }
      for (var stu in this.studentList) {
        var student = this.studentList[stu];

        var index = parseInt(stu) + 1;
        if (student.name == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u5B66\u5458\u59D3\u540D!",
            offset: 300
          });
          return false;
        } else if (student.mobile == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u624B\u673A\u53F7!",
            offset: 300
          });
          return false;
        } else if (!that.checkMobiles(student.mobile)) {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u624B\u673A\u53F7\u7801\u683C\u5F0F\u6709\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165!",
            offset: 300
          });
          return false;
        } else if (student.cardId == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u8EAB\u4EFD\u8BC1\u53F7!",
            offset: 300
          });
          return false;
        }
      }
      return true;
    },
    submit: function submit(type) {

      this.paymentTitle = type == 'ALP' ? "支付宝支付" : "微信支付";
      if (!this.agreeState) {
        this.$message({
          type: "error",
          message: '请先勾选协议',
          offset: 300
        });
        return;
      }
      if (!this.checkData()) {
        return;
      }
      var params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      params.students[0].positiveImage = this.fileListFront[0].img;
      params.students[0].negativeImage = this.fileListBack[0].img;
      params.type = type;
      if (window.wx && window.wx.miniProgram) {
        window.wx.miniProgram.postMessage({
          data: {
            type: 'requestPayment',
            payload: {
              orderId: params.students[0].orderId,
              price: this.totalFee
            }
          }
        });
      }
      var that = this;
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/pre/check',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          that.payDialogVisible = true;

          that.payImgUrlList = [resData.data.url];

          that.$ajax({
            method: "post",
            url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/saveFile',
            data: {
              negativeImage: params.students[0].negativeImage,
              orderId: params.students[0].orderId,
              positiveImage: params.students[0].positiveImage
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
          }).then(function (res) {});
          that.getStatus(resData.data.orderId);
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '接口异常，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    getStatus: function getStatus(orderId) {
      var _this3 = this;

      var that = this;

      clearInterval(this.getStatusTemp);
      this.getStatusTemp = setInterval(function () {
        _this3.$ajax({
          method: "get",
          url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/payment/getInfo/' + orderId,
          headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
        }).then(function (res) {
          if (res.data.status == 1) {
            that.payDialogVisible = false;
            that.nowPay();
            clearInterval(that.getStatusTemp);
          }
        });
      }, 1000);
    },
    policySave: function policySave(type) {
      var params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      if (type) {
        params.payImage = this.fileListPay[0].url;
      }
      console.log(params);
      var that = this;
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/save',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          that.$message({
            type: "success",
            message: '提交成功',
            offset: 200
          });
          that.payDialogVisible = false;
          that.$router.go(-1);
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    beforeUploadPay: function beforeUploadPay(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (['png', 'jpg', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          message: '仅支持JPG、PNG格式文件',
          type: 'warning',
          offset: 200
        });
        return false;
      }
      var size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          type: "warning",
          message: "上传文件的大小不能超过10M",
          offset: 200
        });
        return false;
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '正在上传中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    onSuccessPay: function onSuccessPay(response, file, fileList) {
      console.log(response);
      console.log(file);
      if (response.success) {
        this.fileListPay = [{
          name: file.name,
          url: response.data
        }];
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
      } else {
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
        this.$message({
          type: "error",
          message: response.errorMsg,
          offset: 200
        });
      }
    },
    onErrorPay: function onErrorPay(file, fileList) {
      this.uploadLoading.close();
      this.$refs.upload.clearFiles();
      this.$message({
        type: "error",
        message: '文件上传失败，请重试！',
        offset: 200
      });
    },
    handleRemove: function handleRemove(file) {
      this.fileListPay = [];
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    nowPay: function nowPay() {

      this.payDialogVisible = false;
      this.studentList = [];
      this.$router.push("/");
    },
    waitPay: function waitPay() {
      this.policySave();
    }
  },
  watch: {
    '$route': function $route(to, from) {
      console.log("to", to, from);
      if (to.query.productId && to.query.productId !== from.query.productId) {
        this.studentList = [];
        this.totalFee = '0.00';
        this.productId = this.$route.query.productId || '0';
        this.init();
      }
    },

    'studentList': {
      handler: function handler(v) {
        var len = v.length;
        this.totalFee = len * this.singleFee;
      },

      deep: true
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast_style__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_api__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "toubaoView",
  components: {
    tbxz: __WEBPACK_IMPORTED_MODULE_4__rules_tbxz_vue___default.a, fwxy: __WEBPACK_IMPORTED_MODULE_5__rules_fwxy_vue___default.a, khgzs: __WEBPACK_IMPORTED_MODULE_6__rules_khgzs_vue___default.a
  },
  data: function data() {
    return {
      fileListFront: [],
      fileListBack: [],
      getStatusTemp: null,
      hasData: false,
      agreeState: false,
      paymentTitle: '微信支付',
      studentList: [{
        name: '',
        cardId: '',
        mobile: ''
      }],
      downloadFile: '',
      fileList: [],
      singleFee: 0,
      totalFee: '0.00',
      payDialogVisible: false,
      fileListPay: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      headers: {},
      uploadUrl: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/minio/upload/niu.pay',
      dialogVisiblePay: false,
      dialogVisibleProtocol: false,
      payImgUrlList: [],
      productId: '',
      productName: '',
      dsName: '',
      dsSocialCode: '',
      ruleTypes: 1,
      loading: true
    };
  },
  mounted: function mounted() {
    this.headers = { 'Authorization': localStorage.getItem('token') };
    this.productId = this.$route.query.productId || '0';
    this.init();
  },

  methods: {
    deletePhoto: function deletePhoto(file, type) {
      var url = __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/minio/remove/cert";
      var that = this;
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          fileName: file.img
        },
        headers: { 'Content-Type': 'application/json' }
      }).then(function (res) {
        self.ajaxState = true;
        var data = res.data;
        if (data.success) {} else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
        }
      }).catch(function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('网络异常，请重试！');
      });
    },
    beforeRead: function beforeRead(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.resizeCount = 1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('图片大小不能超过10M');
        return false;
      }
      return true;
    },
    afterRead: function afterRead(file, type) {
      var _this = this;

      console.log(file);
      var url = __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/minio/upload/cert/image';
      var that = this;
      var config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      var formdata = new FormData();
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var img = new Image();
      img.src = file.content;
      console.log('0', file.content.length / 1024);
      var imageSize = file.content.length || 100;
      if (imageSize <= 10 * 1024 * 1024 && imageSize > 8 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 8 * 1024 * 1024 && imageSize > 6 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 6 * 1024 * 1024 && imageSize > 4 * 1024 * 1024) {
        this.resizeCount = 2.5;
      } else if (imageSize <= 4 * 1024 * 1024 && imageSize > 2 * 1024 * 1024) {
        this.resizeCount = 1.5;
      } else {
        this.resizeCount = 1;
      }
      console.log(this.resizeCount);
      img.onload = function () {
        if (_this.resizeCount > 1) {
          canvas.width = img.width / _this.resizeCount;
          canvas.height = img.height / _this.resizeCount;
          context.drawImage(img, 0, 0, img.width / _this.resizeCount, img.height / _this.resizeCount);
          file.content = canvas.toDataURL(file.file.type, 1);
        }
        var files = _this.dataURLtoFile(file.content, file.file.name);
        formdata.append('file', files);
        console.log('1', file.content.length / 1024);
        formdata.append('token', localStorage.getItem('infoToken'));
        _this.$ajax.post(url, formdata, config).then(function (res) {
          var data = res.data;
          if (data.success) {
            if (type == '1') {
              that.fileListFront[0].img = data.data;

              that.loading = true;
              that.$ajax({
                method: "post",
                url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + "applets-server/api/order/getIdCardInfo",
                data: {
                  url: that.fileListFront[0].img
                },
                headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
              }).then(function (res) {
                if (res.data.success && res.data.data != '' && res.data.data != null) {
                  that.studentList[0].name = res.data.data.name;
                  that.studentList[0].cardId = res.data.data.idNum;
                  that.loading = false;
                } else {
                  that.$message({
                    type: 'error',
                    message: "身份证识别失败！"
                  });
                  that.loading = false;
                }
              }).catch(function (e) {
                {
                  console.log(e);
                  that.loading = false;
                }
              });
            } else {
              that.fileListBack[0].img = data.data;
            }
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])(data.errorMessage || '接口失败，请重试！');
            if (type == '1') {
              that.fileListFront = [];
            } else {
              that.fileListBack = [];
            }
          }
        }).catch(function (err) {
          if (type == '1') {
            that.fileListFront = [];
          } else {
            that.fileListBack = [];
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */])('网络异常，请重试！');
        });
      };
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    init: function init() {
      var that = this;
      this.$ajax({
        method: "get",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + ("applets-server/api/policyPc/init/" + this.productId),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          var productMap = resData.data.productMap || {};
          that.downloadFile = productMap.templateUrl || '';
          that.singleFee = productMap.productFee || 0;
          that.totalFee = that.singleFee;
          that.payImgUrlList = (productMap.payUrl || '').split(',');
          that.productName = productMap.productName || '';
          var schoolMap = resData.data.schoolMap || {};
          that.dsName = schoolMap.dsName || '';
          that.dsSocialCode = schoolMap.dsSocialCode || '';
          that.studentList = resData.data.students != '' && resData.data.students != null && resData.data.students.length === 1 ? resData.data.students : [{
            name: '',
            cardId: '',
            mobile: ''
          }];

          if (that.studentList != null && that.studentList.length == 1 && that.studentList[0].positiveImage) {
            that.fileListFront = [{
              url: that.studentList[0].positiveImage,
              img: that.studentList[0].positiveImage
            }];
          }
          if (that.studentList != null && that.studentList.length == 1 && that.studentList[0].negativeImage) {
            that.fileListBack = [{
              url: that.studentList[0].negativeImage,
              img: that.studentList[0].negativeImage
            }];
          }
          if (that.studentList != '' && that.studentList != null && that.studentList.length > 0) {
            that.hasData = true;
          } else {
            that.hasData = false;
          }

          that.loading = false;
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    toAgree: function toAgree() {
      this.agreeState = !this.agreeState;
    },
    toRule: function toRule(type) {
      this.dialogVisibleProtocol = true;
      this.ruleTypes = type;
    },
    delStudent: function delStudent(index) {
      this.studentList.splice(index, 1);
    },
    addStudent: function addStudent() {
      var newStu = {
        name: '',
        cardId: '',
        mobile: ''
      };
      this.studentList.push(newStu);
    },
    beforeUpload: function beforeUpload(file) {
      var _this2 = this;

      var that = this;
      var _file = file;
      var fileReader = new FileReader();
      fileReader.onload = function (ev) {
        try {
          var data = ev.target.result;
          var workbook = XLSX.read(data, {
            type: 'binary'
          });
          for (var sheet in workbook.Sheets) {
            var sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);

            if (sheetArray.length == 0) {
              continue;
            }

            for (var stu in sheetArray) {
              var thisStu = sheetArray[stu];

              var newStu = {
                name: thisStu['姓名'],
                cardId: thisStu['身份证'],
                mobile: thisStu['手机号']
              };
              that.studentList.push(newStu);
            }
          }
        } catch (e) {
          _this2.$message.warning('文件类型不正确！');
        }
      };
      fileReader.readAsBinaryString(_file);
    },
    checkMobiles: function checkMobiles(number) {
      return (/^((1)+\d{10})$/.test(number)
      );
    },
    checkData: function checkData() {
      var that = this;
      for (var stu in this.studentList) {
        var student = this.studentList[stu];

        if (this.studentList[stu]['cardId']) {

          this.studentList[stu]['cardId'] = this.studentList[stu]['cardId'].trim();
        }
        var index = parseInt(stu) + 1;
        if (student.name == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u5B66\u5458\u59D3\u540D!",
            offset: 300
          });
          return false;
        } else if (student.mobile == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u624B\u673A\u53F7!",
            offset: 300
          });
          return false;
        } else if (!that.checkMobiles(student.mobile)) {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u624B\u673A\u53F7\u7801\u683C\u5F0F\u6709\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165!",
            offset: 300
          });
          return false;
        } else if (student.cardId == '') {
          that.$message({
            type: "error",
            message: "\u7B2C" + index + "\u5B66\u5458\u4FE1\u606F\u586B\u5199\u9519\u8BEF\uFF1A\u8BF7\u586B\u5199\u8EAB\u4EFD\u8BC1\u53F7!",
            offset: 300
          });
          return false;
        }
      }
      return true;
    },
    submit: function submit(type) {

      this.paymentTitle = type == 'ALP' ? "支付宝支付" : "微信支付";
      if (!this.agreeState) {
        this.$message({
          type: "error",
          message: '请先勾选协议',
          offset: 300
        });
        return;
      }
      if (!this.checkData()) {
        return;
      }
      var params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      params.students[0].positiveImage = this.fileListFront[0].img;
      params.students[0].negativeImage = this.fileListBack[0].img;
      params.type = type;
      if (window.wx && window.wx.miniProgram) {
        window.wx.miniProgram.postMessage({
          data: {
            type: 'requestPayment',
            payload: {
              orderId: params.students[0].orderId,
              price: this.totalFee
            }
          }
        });
      }
      var that = this;
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/pre/check',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          that.payDialogVisible = true;

          that.payImgUrlList = [resData.data.url];

          that.$ajax({
            method: "post",
            url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/saveFile',
            data: {
              negativeImage: params.students[0].negativeImage,
              orderId: params.students[0].orderId,
              positiveImage: params.students[0].positiveImage
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
          }).then(function (res) {});
          that.getStatus(resData.data.orderId);
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '接口异常，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    getStatus: function getStatus(orderId) {
      var _this3 = this;

      var that = this;

      clearInterval(this.getStatusTemp);
      this.getStatusTemp = setInterval(function () {
        _this3.$ajax({
          method: "get",
          url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/payment/getInfo/' + orderId,
          headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
        }).then(function (res) {
          if (res.data.status == 1) {
            that.payDialogVisible = false;
            that.nowPay();
            clearInterval(that.getStatusTemp);
          }
        });
      }, 1000);
    },
    policySave: function policySave(type) {
      var params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      if (type) {
        params.payImage = this.fileListPay[0].url;
      }
      console.log(params);
      var that = this;
      this.$ajax({
        method: "post",
        url: __WEBPACK_IMPORTED_MODULE_3__components_common_api__["a" /* Config */].api_url + 'applets-server/api/policyPc/save',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params),
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') }
      }).then(function (res) {
        var resData = res.data;
        if (resData.success) {
          that.$message({
            type: "success",
            message: '提交成功',
            offset: 200
          });
          that.payDialogVisible = false;
          that.$router.go(-1);
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(function (err) {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    beforeUploadPay: function beforeUploadPay(file) {
      var FileExt = file.name.replace(/.+\./, "");
      if (['png', 'jpg', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          message: '仅支持JPG、PNG格式文件',
          type: 'warning',
          offset: 200
        });
        return false;
      }
      var size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          type: "warning",
          message: "上传文件的大小不能超过10M",
          offset: 200
        });
        return false;
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '正在上传中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    onSuccessPay: function onSuccessPay(response, file, fileList) {
      console.log(response);
      console.log(file);
      if (response.success) {
        this.fileListPay = [{
          name: file.name,
          url: response.data
        }];
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
      } else {
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
        this.$message({
          type: "error",
          message: response.errorMsg,
          offset: 200
        });
      }
    },
    onErrorPay: function onErrorPay(file, fileList) {
      this.uploadLoading.close();
      this.$refs.upload.clearFiles();
      this.$message({
        type: "error",
        message: '文件上传失败，请重试！',
        offset: 200
      });
    },
    handleRemove: function handleRemove(file) {
      this.fileListPay = [];
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    nowPay: function nowPay() {

      this.payDialogVisible = false;
      this.studentList = [];
      this.$router.push("/myOrders");
    },
    waitPay: function waitPay() {
      this.policySave();
    }
  },
  watch: {
    '$route': function $route(to, from) {
      console.log("to", to, from);
      if (to.query.productId && to.query.productId !== from.query.productId) {
        this.studentList = [];
        this.totalFee = '0.00';
        this.productId = this.$route.query.productId || '0';
        this.init();
      }
    },

    'studentList': {
      handler: function handler(v) {
        var len = v.length;
        this.totalFee = len * this.singleFee;
      },

      deep: true
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "index",
  methods: {
    openXueyuan: function openXueyuan(type) {
      if (type == 0) {

        this.$router.push('/orderQuery');
      } else {
        this.$router.push('/dirverLogin');
      }
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "fexy"
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "khgzs"
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "tbxz"
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_list_style__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_list__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_radio_style__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_radio__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_radio_group_style__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_radio_group__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_store__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_resource__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);

















__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vant_es_radio_group__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vant_es_radio__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui___default.a);


__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_list__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11_axios___default.a.defaults.withCredentials = true;

__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_11_axios___default.a;
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.hrefUrl = window.location.href.split('#')[0];
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_6_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_8__App___default.a
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(113);


var actions = {
  syncToastState: function syncToastState(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state;
    var showToast = _ref2.showToast,
        toastLabel = _ref2.toastLabel;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SYNC_TOAST_STATE */], { showToast: showToast, toastLabel: toastLabel });
  },
  changeSimColor: function changeSimColor(store, color) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      store.commit('newSimObject', color);
      resolve();
    });
  }
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toast", function() { return toast; });
var loading = function loading(state) {
  var show = state.app.showLoading;
  var label = state.app.loadingLabel;
  return { show: show, label: label };
};

var toast = function toast(state) {
  var show = state.app.showToast;
  var label = state.app.toastLabel;
  return { show: show, label: label };
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(113);


var _mutations;



var state = {
  user: {},

  setComponentsItems: [{ 'component': 'setPageTitle', 'index': 0, 'fixed': true }],

  getComponentsItems: [],
  showLoading: false,
  loadingLabel: '加载中...',
  showToast: false,
  toastLabel: '操作成功',

  pageData: {},

  consult: [{
    consultFont: '在线咨询',
    consultColor: '#118ee9',
    isMajorColor: '1',
    right: '35px',
    top: '5px',
    hrefUrl: '',
    width: '',
    height: '',
    radius: ''
  }],

  radioPreview: 1,
  sideMenuName: 'workPlace',
  breadName1: { id: '', name: '' },
  breadName2: { id: '', name: '' }
};

var mutations = (_mutations = {
  newUser: function newUser(state, msg) {
    state.user = msg;
  },
  newForbidHistory: function newForbidHistory(state, msg) {
    state.forbidHistory = msg;
  },
  newSetComponentsItems: function newSetComponentsItems(state, msg) {
    state.setComponentsItems = msg;
  },
  newGetComponentsItems: function newGetComponentsItems(state, msg) {
    state.getComponentsItems = msg;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SYNC_TOAST_STATE */], function (state, _ref) {
  var showToast = _ref.showToast,
      toastLabel = _ref.toastLabel;

  state.showToast = showToast;
  state.toastLabel = toastLabel;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newPageData', function newPageData(state, msg) {
  state.pageData = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newConsult', function newConsult(state, msg) {
  state.consult = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newRadioPreview', function newRadioPreview(state, msg) {
  state.radioPreview = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newSideMenuName', function newSideMenuName(state, msg) {
  state.sideMenuName = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newBreadName1', function newBreadName1(state, msg) {
  state.breadName1 = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'newBreadName2', function newBreadName2(state, msg) {
  state.breadName2 = msg;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  pageTitle: '落地页',

  pageUrl: '',

  screenType: 'vertical',

  effectH: 0,

  saveShowModal: false,

  topImgShow: false,

  topImgFileList: [],
  topImgName: '',

  embedCode: {
    codeUrl: '',
    codeContent: '',
    embedCodeEffective: ''
  },

  embedCodeSave: {
    codeUrl: '',
    codeContent: '',
    embedCodeEffective: ''
  },
  isDisable: false,

  countDown: {
    endTime: '', showEndTime: 0, countStyle: 0, bgRadio: 0, bgColor: '#000000', bgImg: '', fontPosition: 0, fontSize: 14, fontColor: '#ffffff'
  },
  hideCount: true,

  tAEntrance: {
    place: 1, wHeight: 200, showType: 2, bgColor: '#000000', fontColor: '#ffffff',
    font1: '免流中 流量详情', font2: '已有王卡 登录激活', font3: '',
    img1: '', img2: '', img3: ''
  },

  tAShow: 1,

  tNotice: {
    bgColor: '#fff3cb', fontColor: '#a27733',
    font: 'XX产品将于近期停售，我们会在**月**日起下架产品，欢迎继续关注其他套餐，谢谢！'
  },
  topUploadType: 1
};

var mutations = {
  newIsDisable: function newIsDisable(state, msg) {
    state.isDisable = msg;
  },
  newPageTitle: function newPageTitle(state, msg) {
    state.pageTitle = msg;
  },
  newPageUrl: function newPageUrl(state, msg) {
    state.pageUrl = msg;
  },
  newScreenType: function newScreenType(state, msg) {
    state.screenType = msg;
  },
  newEffectH: function newEffectH(state, msg) {
    state.effectH = msg;
  },
  newSaveShowModal: function newSaveShowModal(state, msg) {
    state.saveShowModal = msg;
  },
  newTopImgShow: function newTopImgShow(state, msg) {
    state.topImgShow = msg;
  },
  newTopImgFileList: function newTopImgFileList(state, msg) {
    state.topImgFileList = msg;
  },
  newTopImgName: function newTopImgName(state, msg) {
    state.topImgName = msg;
  },
  newEmbedCode: function newEmbedCode(state, msg) {
    state.embedCode = msg;
  },
  newEmbedCodeSave: function newEmbedCodeSave(state, msg) {
    state.embedCodeSave = msg;
  },
  newCountDown: function newCountDown(state, msg) {
    state.countDown = msg;
  },
  newHideCount: function newHideCount(state, msg) {
    state.hideCount = msg;
  },
  newTAEntrance: function newTAEntrance(state, msg) {
    state.tAEntrance = msg;
  },
  newTAShow: function newTAShow(state, msg) {
    state.tAShow = msg;
  },
  newTNotice: function newTNotice(state, msg) {
    state.tNotice = msg;
  },
  newTopUploadType: function newTopUploadType(state, msg) {
    state.topUploadType = msg;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(479),
  /* scopeId */
  "data-v-558acec2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-2f4d04b3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)
__webpack_require__(367)
__webpack_require__(365)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  "data-v-3646e68f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  "data-v-206e46ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(489),
  /* scopeId */
  "data-v-c6ab6cd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  "data-v-24dd4db9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  "data-v-2d041680",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-286ef22a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  "data-v-430401ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)
__webpack_require__(376)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  "data-v-65fd0588",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)
__webpack_require__(373)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  "data-v-587a2574",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(490),
  /* scopeId */
  "data-v-f6a7dd50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleContent"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("投保须知")]), _vm._v(" "), _c('p', [_vm._v("1.本产品由北部湾财产保险股份有限公司承保，升华茂林保险销售有限公司四川分公司为唯一代理商，云南祐祉商务信息咨询有限公司（指定投保人）旗下（学驾易）为唯一服务科技平台。")]), _vm._v(" "), _c('p', [_vm._v("2. 适用条款")]), _vm._v(" "), _c('p', [_vm._v("本保单适用《北部湾财险驾驶培训人员重新报名费用损失保险》（2021版）条款\n    ) ")]), _vm._v(" "), _c('p', [_vm._v(" 。请投保人了解、同意并确认上述条款内容，特别是保险责任及责任免除的部分。购买本保险产品即表示投保人同意接受本产品条款及投保须知的全部内容。")]), _vm._v(" "), _c('p', [_vm._v("3.如实告知")]), _vm._v(" "), _c('p', [_vm._v("根据《保险法》相关要求， 投保人在投保时须保证投保信息 真实有效， 如投保人未能履行如实告知义务，须承担相应后果：")]), _vm._v(" "), _c('p', [_vm._v("( 1 ) 投保人故意或者因重大过失未履行前款规定的如实告 知义务，足以影响保险人决定是否同意承保或者提高保险费率的， 保险人有权解除合同。")]), _vm._v(" "), _c('p', [_vm._v("(2) 投保人故意不履行如实告知义务的， 保险人对于合同 解除前发生的保险事故， 不承担赔偿或者给付保险金的责任， 并 不退还保险费。")]), _vm._v(" "), _c('p', [_vm._v("(3) 投保人因重大过失未履行如实告知义务， 对保险事故 的发生有严重影响的， 保险人对于合同解除前发生的保险事故， 不承担赔偿或者给付保险金的责任， 但应当退还保险费。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("4.产品介绍")]), _vm._v(" "), _c('p', [_vm._v("(1) 被保险人： 学员；")]), _vm._v(" "), _c('p', [_vm._v("(2) 投保人： 云南祐祉商务信息咨询有限公司；")]), _vm._v(" "), _c('p', [_vm._v("(3) 承保学员年龄： 18-60 周岁 (含) ；")]), _vm._v(" "), _c('p', [_vm._v("(4) 承保范围： 本保单仅限于首次申领 C1、C2 证的驾校学 员 (准驾车型以交警部门通告为准)")]), _vm._v(" "), _c('p', [_vm._v("(5) 投保时间： 须在首次科目一考试前至少 1 天投保；")]), _vm._v(" "), _c('p', [_vm._v("(6) 本保险同一学员限投保一份， 多投无效；")]), _vm._v(" "), _c('p', [_vm._v("(7) 学员因缺考造成的考试不通过， 不承担赔偿责任 (科 目一 0 分， 科 目 四 0 分， 不予赔付) ；")]), _vm._v(" "), _c('p', [_vm._v("(8) 保险期限内， 学员提前取得驾驶证， 则该学员的保险 责任自行终止(取得驾驶证之 日 24 时止)；")]), _vm._v(" "), _c('p', [_vm._v("(9) 学员因任何原因导致报考驾校与投保驾校不符所产生 的补考费用不予赔付。")]), _vm._v(" "), _c('p', [_vm._v("(10)本保险主险仅承保因被保险人过失导致保单列明的学 员死亡及残疾，被保险人依法应承担的经济赔偿责任；")]), _vm._v(" "), _c('p', [_vm._v("(11) 本保单赔偿项目限于学员考试不过产生的补考费 用，赔偿限额不超过方案列明限额。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("(12)如果在异地考试，以投保地该科目赔付标准与考试地 该科目赔付标准取低进行赔付。")]), _vm._v(" "), _c('p', [_vm._v("(13) 考试成绩显示后5 个工作日内须完成报案，超出报 案时间不予赔付。")]), _vm._v(" "), _c('p', [_vm._v("(14) 赔偿约定：")]), _vm._v(" "), _c('p', [_vm._v("每人限额：科 目二、科 目三、赔付标准( 元 ) 以当地补考费用为标准 。")]), _vm._v(" "), _c('p', [_vm._v("科 目二、科 目 三、科 目 四最多赔付 4 次， 累计不超过补考保障限额；")]), _vm._v(" "), _c('p', [_vm._v("责任限额： 本保单《北部湾财险驾驶培训人员重新报名费用损失保险》项下： 每人补考费用补偿责任限额为方案列明限额 。")]), _vm._v(" "), _c('p', [_vm._v("5.补偿流程")]), _vm._v(" "), _c('p', [_vm._v("学员考试未通过挂科后通过学驾易平台在线申请补偿，并提供相应理 赔资料。")]), _vm._v(" "), _c('p', [_vm._v("具体需提供材料如下：")]), _vm._v(" "), _c('p', [_vm._v("( 1 )保单信息： 学员姓名、身份证号、手机号、考试省份；")]), _vm._v(" "), _c('p', [_vm._v("（2）补偿科目信息： 补偿科目、补偿科目考试日期；")]), _vm._v(" "), _c('p', [_vm._v("（3）影像信息：授权书扫描件；")]), _vm._v(" "), _c('p', [_vm._v("(2)其他材料：驾校赔款收款账户信息、学员122网站登陆账号及密码。")]), _vm._v(" "), _c('p', [_vm._v("6.保单及发票")]), _vm._v(" "), _c('p', [_vm._v("本保险为您提供电子保单及电子发票，根据国家相关法律法规规定，数据电文是合法的合同表现形式，电子保险凭证、电子发票具有法律效力。")]), _vm._v(" "), _c('p', [_vm._v("7.相关授权")]), _vm._v(" "), _c('p', [_vm._v("\n    为提供保险服务，及为依法履行反洗钱和反恐怖融资职责或者义务，您（投保人/被保险人）同意鼎和财产保险股份有限公司及其服务必要而委托的第三方基于为您提供服务、服务管控及洗钱风险管控等用途，在承保前后可以收集、整理、保存、加工、核实、调查、提供和使用您授权的及享受鼎和财产保险股份有限公司服务必要的相关信息，但法律禁止的除外北部湾财产保险股份有限公司及其委托的第三方对上述信息负有保密义务。")]), _vm._v(" "), _c('p', [_vm._v("8.偿付能力告知")]), _vm._v(" "), _c('p', [_vm._v("北部湾财产保险股份有限公司最近季度的综合偿付能力充足，风险综合评级为B 级，综合偿付能力充足率和风险综合评级均达到监管要求。")])])
}]}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('van-button', {
    attrs: {
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.orderQuery
    }
  }, [_vm._v("返回")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "width": "100%",
      "height": "360",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "http://new.ynyzxjy.cn/newBaoPublic/static/mp4/learn_apply.mp4",
      "type": "video/mp4",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  })])
}]}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "query"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("订单查询")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certNo),
      expression: "certNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号码",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.certNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.certNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%",
      "font-size": "15px"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.queryOrder
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', [_c('myInfo', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "certNo": _vm.certNo
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("补偿申请")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('van-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(0)
      }
    }
  }, [_vm._v("购买")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "info",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(1)
      }
    }
  }, [_vm._v("我的订单")])], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin": "5px"
    }
  }, [_c('van-field', {
    attrs: {
      "size": "small",
      "placeholder": "请输入学员姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.searchValue.name),
      callback: function($$v) {
        _vm.$set(_vm.searchValue, "name", $$v)
      },
      expression: "searchValue.name"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "info",
      "size": "small",
      "block": ""
    },
    on: {
      "click": _vm.queryList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('van-cell', {
      key: item.orderId
    }, [_c('div', {
      staticClass: "showInfo",
      on: {
        "click": function($event) {
          return _vm.openShowInfo(item)
        }
      }
    }, [_c('div', [_vm._v("学员姓名：" + _vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v("证件号：" + _vm._s(item.certId))]), _vm._v(" "), _c('div', [_vm._v("订单状态：" + _vm._s(item.orderStateName))]), _vm._v(" "), _c('div', [_vm._v("产品名称：" + _vm._s(item.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : item.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))]), _vm._v(" "), _c('div', [_vm._v("开始日期：" + _vm._s(item.insuranceStartTime))])])])
  }), 1), _vm._v(" "), (_vm.openShow) ? _c('van-popup', {
    style: ({
      height: '100%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-popstate": true,
      "closeable": true
    },
    model: {
      value: (_vm.openShow),
      callback: function($$v) {
        _vm.openShow = $$v
      },
      expression: "openShow"
    }
  }, [_c('el-descriptions', {
    attrs: {
      "border": "",
      "column": 1
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "保单编号"
    }
  }, [_vm._v(_vm._s(_vm.order.insuranceNo))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_vm._v(_vm._s(_vm.order.createTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "支付时间"
    }
  }, [_vm._v(_vm._s(_vm.order.payTime))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品价格"
    }
  }, [_vm._v(_vm._s(_vm.order.orderFee + ' 元'))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品ID"
    }
  }, [_vm._v(_vm._s(_vm.order.productId))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "产品名称"
    }
  }, [_vm._v(_vm._s(_vm.order.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.order.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "驾校名称"
    }
  }, [_vm._v(_vm._s(_vm.order.dsName))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_vm._v(_vm._s(_vm.order.name))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "证件号"
    }
  }, [_vm._v(_vm._s(_vm.order.certId))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(_vm._s(_vm.order.contactNumber))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.order.orderStateName))])], 1), _vm._v(" "), (_vm.order.orderStateName == '保障中') ? _c('el-descriptions-item', {
    attrs: {
      "label": "保障时间"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.order.insuranceStartTime + '至' + _vm.order.insuranceEntTime))]) : _vm._e(), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "正面图片"
    }
  }, [(_vm.order.positiveImage !== '') ? _c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "50px"
    },
    attrs: {
      "alt": "点击预览",
      "src": _vm.order.positiveImage,
      "preview-src-list": _vm.imagesUrl
    }
  }, [_c('div', {
    staticClass: "image-slot imageSlot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.positiveImage === '') ? _c('span', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "反面图片"
    }
  }, [(_vm.order.negativeImage !== '') ? _c('el-image', {
    staticStyle: {
      "width": "150px",
      "height": "50px"
    },
    attrs: {
      "alt": "点击预览",
      "src": _vm.order.negativeImage,
      "preview-src-list": _vm.imagesUrl
    }
  }, [_c('div', {
    staticClass: "image-slot imageSlot",
    attrs: {
      "slot": "error"
    },
    slot: "error"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.negativeImage === '') ? _c('span', [_vm._v("-")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boyindex"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "24px",
      "width": "100%",
      "text-align": "center",
      "color": "#fff",
      "font-weight": "600"
    }
  }, [_vm._v("\n      登录中心\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-radius": "10px"
    },
    attrs: {
      "placeholder": "请输入用户账号"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-radius": "10px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-top-left-radius": "10px",
      "border-bottom-left-radius": "10px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.captcha),
      callback: function($$v) {
        _vm.captcha = $$v
      },
      expression: "captcha"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "getImgCaptcha",
    staticStyle: {
      "border-top-right-radius": "10px",
      "border-bottom-right-radius": "10px"
    },
    attrs: {
      "src": _vm.imgCaptcha,
      "alt": ""
    },
    on: {
      "click": _vm.getImgCaptcha
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('van-button', {
    staticStyle: {
      "border-radius": "10px",
      "font-size": "18px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("立即登录")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-finish",
    style: ({
      height: _vm.isPhone ? 'calc(100vh - 120px)' : '570px'
    })
  }, [(_vm.isPhone) ? _c('div', {
    staticClass: "wrap2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "actionsWrap"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear2
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo2
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview2
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('canvas', {
    ref: "canvas2",
    staticClass: "canvas",
    staticStyle: {
      "flex": "1"
    }
  })]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "wrap1",
    staticStyle: {
      "margin-top": "0px",
      "height": "550px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('canvas', {
    ref: "canvas1",
    staticClass: "canvas1",
    staticStyle: {
      "width": "800px",
      "height": "400px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear1
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo1
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview1
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding": "10px",
      "text-align": "center",
      "transform": "translateY(-50%) rotate(90deg)",
      "width": "600px",
      "height": "20px",
      "position": "absolute",
      "top": "50%"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("交管12123")]), _vm._v(" 扫码，获取挂科材料\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "26px",
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("交管12123")]), _vm._v(" 扫码，获取挂科材料\n    ")])
}]}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isState),
      expression: "!isState"
    }],
    staticClass: "loginEwm"
  }, [(_vm.ewmUrl == '') ? _c('div', {
    staticClass: "waitMask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "#1989fa"
    }
  }), _vm._v(" "), _c('p', [_vm._v("二维码生成中...")])], 1) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.ewmUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("请使用补偿本人的交管12123App扫一扫登录（补偿还需要获取您的驾考信息作为凭证，请尽快完成扫码登录，二维码会在3分钟后失效哦）")])]), _vm._v(" "), (_vm.processFlag) ? _c('div', {
    staticClass: "process"
  }, [_c('van-progress', {
    attrs: {
      "percentage": _vm.processNum,
      "stroke-width": "8"
    }
  }), _vm._v(" "), _vm._m(0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isState),
      expression: "isState"
    }],
    staticClass: "stateDiv"
  }, [(_vm.stateType == 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(401),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(400),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.stateType == 1) ? _c('p', {
    staticClass: "desc"
  }, [_vm._v("补偿申请成功")]) : _c('p', {
    staticClass: "desc"
  }, [_vm._v("补偿申请失败"), _c('span', [_vm._v(_vm._s(_vm.errorDesc))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "margin": "20px 0px"
    }
  }, [_vm._v("如果二维码超过一分钟未加载，请点击重新获取二维码")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%",
      "margin-top": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getLoginImage
    }
  }, [_vm._v("重新获取二维码")]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tips"
  }, [_vm._v("系统正在自动获取驾考信息，请您耐心等待，"), _c('br'), _vm._v("不要关闭当前页面！")])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('van-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [(_vm.accountFlag == '1') ? _c('van-collapse-item', {
    staticClass: "backCollapseItem",
    attrs: {
      "name": "1"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "activeTitles"
        }, [_vm._v("账号信息")])]
      },
      proxy: true
    }], null, false, 538426519)
  }, [_vm._v(" "), _c('ul', {
    staticClass: "messageUl"
  }, [_c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人姓名")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeeName != '请填写收款人姓名'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeeName),
      expression: "payeeName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写收款人姓名"
    },
    domProps: {
      "value": (_vm.payeeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeeName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人身份证号")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeeCertNo != '请填写收款人身份证号'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeeCertNo),
      expression: "payeeCertNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写收款人身份证号"
    },
    domProps: {
      "value": (_vm.payeeCertNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeeCertNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人电话")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeePhone != '请填写收款人电话'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeePhone),
      expression: "payeePhone"
    }],
    attrs: {
      "type": "number",
      "placeholder": "请填写收款人电话"
    },
    domProps: {
      "value": (_vm.payeePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeePhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行名称")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankName != '请填写银行名称'
    }
  }, [_c('van-field', {
    attrs: {
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "placeholder": "请填写银行名称"
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankCode != '请填写银行账号'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankCode),
      expression: "bankCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行账号"
    },
    domProps: {
      "value": (_vm.bankCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankCode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.bankListFlag) ? _c('div', {
    staticClass: "bankList"
  }, _vm._l((_vm.bankList), function(item, index) {
    return _c('span', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.selBankList(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.bankName) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行所在省份")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankProvinceName != '请填写银行所在省份'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankProvinceName),
      expression: "bankProvinceName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行所在省份"
    },
    domProps: {
      "value": (_vm.bankProvinceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankProvinceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行所在地市")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankCityName != '请填写银行所在地市'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankCityName),
      expression: "bankCityName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行所在地市"
    },
    domProps: {
      "value": (_vm.bankCityName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankCityName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("开户支行")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankSubName != '请填写开户支行'
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写开户支行"
    },
    on: {
      "focus": _vm.bankSubNameClick,
      "input": function($event) {
        return _vm.querySubBank(_vm.bankSubName)
      },
      "blur": _vm.bankSubNameBlur
    },
    model: {
      value: (_vm.bankSubName),
      callback: function($$v) {
        _vm.bankSubName = $$v
      },
      expression: "bankSubName"
    }
  }), _vm._v(" "), (_vm.subBankList.length > 0) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bankSubSelectShow),
      expression: "bankSubSelectShow"
    }],
    staticClass: "bankSubNameSelectDwon",
    staticStyle: {
      "position": "absolute",
      "width": "100%"
    }
  }, _vm._l((_vm.subBankList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "mousedown": function($event) {
          _vm.bankSubName = item
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('van-collapse-item', {
    attrs: {
      "title": "挂科信息",
      "name": "2"
    }
  }, [_c('ul', {
    staticClass: "messageUl"
  }, [_c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科日期"), _c('i', {
    staticStyle: {
      "font-size": "12px",
      "font-style": "normal"
    }
  }, [_vm._v("(当次挂科日期)")])]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.selCurrentDate != '请选择挂科日期'
    },
    on: {
      "click": _vm.openDatetime
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selCurrentDate))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科省")]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.position != '请选择挂科地区'
    },
    on: {
      "click": function($event) {
        return _vm.openCity(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.position))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科市")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxs != '请填写挂科市'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxs),
      expression: "cxs"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科市"
    },
    domProps: {
      "value": (_vm.cxs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科区/县")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxx != '请填写挂科区/县'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxx),
      expression: "cxx"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科区/县"
    },
    domProps: {
      "value": (_vm.cxx)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxx = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科考场名称")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxkcmc != '请填写挂科考场名称'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxkcmc),
      expression: "cxkcmc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科考场名称"
    },
    domProps: {
      "value": (_vm.cxkcmc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxkcmc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("驾校所在地区")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.jxPosition != '请选择驾校所在地'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.jxPosition))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("补偿科目")]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.claimClass != '请选择补偿科目'
    },
    on: {
      "click": _vm.openClaimClass
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.claimClass))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("考试结果")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.result != '请选择考试结果'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.result))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("考试成绩")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.score),
      expression: "score"
    }],
    class: {
      'noGrey': _vm.score != ''
    },
    attrs: {
      "type": "number",
      "placeholder": "请填写考试成绩"
    },
    domProps: {
      "value": (_vm.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.score = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("交管12123密码")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password122),
      expression: "password122"
    }],
    class: {
      'noGrey': _vm.password122 != ''
    },
    attrs: {
      "type": "text",
      "placeholder": "交管12123密码"
    },
    domProps: {
      "value": (_vm.password122)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password122 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("补偿金额")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimFee),
      expression: "claimFee"
    }],
    class: {
      'noGrey': _vm.claimFee != '0'
    },
    attrs: {
      "type": "text",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.claimFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimFee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("是否自动截图")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-radio-group', {
    model: {
      value: (_vm.autoFee),
      callback: function($$v) {
        _vm.autoFee = $$v
      },
      expression: "autoFee"
    }
  }, [_c('van-radio', {
    staticStyle: {
      "margin": "5px 0px"
    },
    attrs: {
      "name": "1"
    }
  }, [_vm._v("自动截图")])], 1)], 1)])]), _vm._v(" "), (_vm.autoFee == '2') ? _c('ul', {
    staticClass: "h5Camera",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("学员信息页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 10)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.stuInfoUrl),
      callback: function($$v) {
        _vm.stuInfoUrl = $$v
      },
      expression: "stuInfoUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试成绩页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 11)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.testScoreUrl),
      callback: function($$v) {
        _vm.testScoreUrl = $$v
      },
      expression: "testScoreUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("首次科目一预约页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 12)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.firstDetailUrl),
      callback: function($$v) {
        _vm.firstDetailUrl = $$v
      },
      expression: "firstDetailUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("挂科科目预约页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 13)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.incidentSubjectUrl),
      callback: function($$v) {
        _vm.incidentSubjectUrl = $$v
      },
      expression: "incidentSubjectUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试费缴纳页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 14)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.testFeeUrl),
      callback: function($$v) {
        _vm.testFeeUrl = $$v
      },
      expression: "testFeeUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试费缴纳页(待缴费)")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 15)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.waitTestFeeUrl),
      callback: function($$v) {
        _vm.waitTestFeeUrl = $$v
      },
      expression: "waitTestFeeUrl"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('van-icon', {
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "spL"
  }, [_vm._v("温馨提示: ")]), _vm._v(" "), _c('span', {
    staticClass: "spR"
  }, [_c('code', [_vm._v("1、实际补偿金额以当地车管所为准!")]), _c('br'), _c('code', [_vm._v("2、挂科日期需要在服务有效期内，有效期1年。")]), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "photo",
    attrs: {
      "data-type": "1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("证件照上传")]), _vm._v(" "), _c('ul', {
    staticClass: "h5Camera"
  }, [_c('li', {
    staticClass: "front"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证正面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 1)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListFront),
      callback: function($$v) {
        _vm.fileListFront = $$v
      },
      expression: "fileListFront"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "behind"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证反面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 2)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListBack),
      callback: function($$v) {
        _vm.fileListBack = $$v
      },
      expression: "fileListBack"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sign"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.gotoSign
    }
  }, [_vm._v(" 手写签名")])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "protocol"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": "18px"
    },
    on: {
      "change": _vm.readBook
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("我已阅读\n")])], 1), _vm._v(" "), _c('van-dialog', {
    style: ({
      top: _vm.isPhone ? '50%' : ''
    }),
    attrs: {
      "title": "手写签名",
      "show-cancel-button": false,
      "showConfirmButton": false,
      "width": _vm.isPhone ? '100%' : '900px'
    },
    model: {
      value: (_vm.signShow),
      callback: function($$v) {
        _vm.signShow = $$v
      },
      expression: "signShow"
    }
  }, [_c('signer', {
    on: {
      "set-sign": _vm.setSign
    }
  })], 1), _vm._v(" "), (_vm.openBtn) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("下一步")])]) : _vm._e()], 1), _vm._v(" "), (_vm.datetimeFlag) ? _c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "",
      "formatter": _vm.formatter
    },
    on: {
      "cancel": _vm.cancelDatetime,
      "confirm": _vm.queryTime
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.provinceListShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.provinceList
    },
    on: {
      "confirm": _vm.onConfirmCity,
      "cancel": _vm.onCancelCity
    }
  }) : _vm._e(), _vm._v(" "), (_vm.claimClassShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.claimClassList
    },
    on: {
      "confirm": _vm.onConfirmClaimClass,
      "cancel": _vm.onCancelClaimClass
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resultShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.resultList
    },
    on: {
      "confirm": _vm.onConfirmResult,
      "cancel": _vm.onCancelResult
    }
  }) : _vm._e(), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.protocolDetailFlag),
      expression: "protocolDetailFlag"
    }],
    staticClass: "protocolDetail"
  }, [_c('h3', [_vm._v("云南祐祉商务信息咨询有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "protocolDetailBox"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n          【特别提醒】在您（以下亦称“本人”）确认本《个人信息使用授权书》（以下简称“本授权书”）之前，请您务必充分阅读本授权书所有内容。由于本授权书内容对您至关重要，如您对本授权书内容有任何疑问，请立即暂停后续操作。一旦您通过本网络服务页面进行确认，即视为您同意以数据电文形式签署本授权书。")]), _vm._v(" "), _c('p', [_vm._v("致：云南祐祉商务信息咨询有限公司（以下称“贵公司”）")]), _vm._v(" "), _c('p', [_vm._v("\n          本人为贵公司代理推广的保险产品中被保险人，现本人拟通过贵公司向（具体以实际承保的为准）提交补偿申请。贵公司和在补偿过程中需收集、了解、使用本人的个人信息资料，用于每次（每笔）补偿中的审核（以下简称“审核”），故本人自愿同意并不可撤销，特做出以下操作授权：")]), _vm._v(" "), _c('p', [_vm._v("1、贵公司有权在收到本人补偿申请后进行下列操作，即采集、查询、验证、整理、保存本人提交的全部信息（简称“申请补偿信息”），并将本人每次申请补偿的信息提供给，由对本人进行审核。")]), _vm._v(" "), _c('p', [_vm._v("2、贵公司有权从处获得本人的补偿审核结果及相关信息，并有权保存全部相关信息供本人进行查询。")]), _vm._v(" "), _c('p', [_vm._v("\n          3、本人确认本授权书所称本人“个人信息”，包括但不限于如下内容：本人姓名、证件类型、证件号码、证件影印件、联系方式、性别、住址、电子邮箱、财务信息、征信信息、个人健康信息、车辆信息等，具体以本人实际提供的个人信息和反馈的信息为准。")]), _vm._v(" "), _c('p', [_vm._v("4、贵公司及收到本人申请补偿信息的，均有权按如下用途及方式使用本人个人信息：")]), _vm._v(" "), _c('p', [_vm._v("（1）审核本人提交的每个补偿申请；")]), _vm._v(" "), _c('p', [_vm._v("（2）进行客户身份信息识别；")]), _vm._v(" "), _c('p', [_vm._v("（3）履行反洗钱义务；")]), _vm._v(" "), _c('p', [_vm._v("（4）监管机构规定需要使用本人个人信息的情况。")]), _vm._v(" "), _c('p', [_vm._v("5、本人因投保和补偿需要，授权贵公司在本人投保保单成功生效后，通过公安部交通安全综合服务管理平台（www.122.gov.cn）查询本人相关的交管、驾考信息等内容。")]), _vm._v(" "), _c('p', [_vm._v("6、本授权书有效期限约定为自本人做出本授权承诺之日起至补偿完成，或补偿申请被拒绝之日止。")]), _vm._v(" "), _c('p', [_vm._v("本人已知悉本授权书上述全部内容的含义及因此产生的法律效力【包括但不限于：上述信息对本人是否可以成功补偿、以及补偿金额等结果产生不利影响的风险】。 本授权书完全是本人真实意思表示，本人同意承担由此产生的一切法律后果。\n          本授权书效力具有独立性，不因相关保险合同或条款无效或被撤销而无效或失效，本授权书一经签署，便不可撤销。")]), _vm._v(" "), _c('div', {
    staticClass: "sign"
  }, [_c('p', [_vm._v("授权人签字：" + _vm._s(_vm.userName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(new Date().getFullYear()) + "年" + _vm._s(new Date().getMonth() + 1) + "月" + _vm._s(new Date().getDate()) + "日")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(399),
      "alt": ""
    },
    on: {
      "click": _vm.closeProtocol
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleContent"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("客 户 告 知 书")]), _vm._v(" "), _c('p', [_vm._v("尊敬的客户：")]), _vm._v(" "), _c('p', [_vm._v("\n    感谢您委托我公司代为办理保险业务。本公司是基于投保人的利益，为投保人与订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪人监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请您仔细阅读，并在回执处予以签字（盖章）确认：")]), _vm._v(" "), _c('p', [_vm._v("一、 公司基本情况")]), _vm._v(" "), _c('p', [_vm._v("(一) 公司名称:升华茂林保险销售服务有限公司四川分公司")]), _vm._v(" "), _c('p', [_vm._v("(二) 营业场所: 成都高新区九兴大道6号B座")]), _vm._v(" "), _c('p', [_vm._v("(三) 统一社会信用代码：91510100MA62NG5B0H")]), _vm._v(" "), _c('p', [_vm._v("(四) 许可证有效期止期：2024年12月26日")]), _vm._v(" "), _c('p', [_vm._v("\n    (五) 业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估，风险管理咨询服务；中国保监会批准的其他业务。")]), _vm._v(" "), _c('p', [_vm._v("(六) 联系电话： 18113098830 ")]), _vm._v(" "), _c('p', [_vm._v("\n    二、 根据保险监管部门的规定，只有持《保险经纪从业人员执业证书》的人员方可从事保险经纪业务，您可要求本公司业务人员出示《保险经纪从业人员执业证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况（http://iir.circ.gov.cn）；")]), _vm._v(" "), _c('p', [_vm._v("三、本公司已按照《保险经纪人监管规定》投保了职业责任保险；")]), _vm._v(" "), _c('p', [_vm._v("四、本公司及高级管理人员与经纪业务相关的、其他保险中介机构不存在关联关系； ")]), _vm._v(" "), _c('p', [_vm._v("五、本公司从业人员会根据您的保险需求与风险承受能力等情况，在客观分析市场上同类保险产品的基础上，为您推荐符合其利益的保险产品；")]), _vm._v(" "), _c('p', [_vm._v("六、本公司从业人员会按照中国保监会的要求向您披露保险产品相关信息。同时，请您仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算等内容，您可以要求本公司从业人员对上述内容进行详细讲解。")]), _vm._v(" "), _c('p', [_vm._v("\n    七、请您向本公司业务人员了解《中华人民共和国保险法》等法律法规中对于索赔时效、补偿时限、合同中止与失效、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失等情形导致的法律后果。")]), _vm._v(" "), _c('p', [_vm._v("八、您同意本公司就本项目通过以下方式收取费用：")]), _vm._v(" "), _c('p', [_vm._v("(一) 向收取佣金                                            是√   否□")]), _vm._v(" "), _c('p', [_vm._v("(二) 向您收取咨询费/服务费                                         是□   否√")]), _vm._v(" "), _c('p', [_vm._v("九、根据《中华人民共和国保险法》的规定，因保险经纪人过错给投保人、被保险人和受益人造成损失的，应依法承担赔偿责任。")]), _vm._v(" "), _c('p', [_vm._v("\n    十、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司进行投诉；发生争议时，双方应及时协商解决，协商不成的，您可以向本公司所在地人民法院提起诉讼。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v(" 升华茂林保险销售服务有限公司四川分公司")])])
}]}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.maskFlag) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, _vm._l((_vm.dataList), function(item, index) {
    return (!_vm.loading) ? _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-items": "center",
        "justify-content": "center",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', [_vm._v("产品名称: " + _vm._s(item.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : item.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : item.productName))]), _vm._v(" "), _c('div', [_vm._v("产品价格(元): " + _vm._s(item.productFee))]), _vm._v(" "), _c('div', [_vm._v("产品介绍: "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(("意外伤残死亡赔偿限额： " + (item.productDisabilityFee + "" || "--") + "（元)\n每人补考费用限额：" + (item.productMakeupFee + "" || "--") + "（元）\n每人意外医疗限额： " + (item.productMedicalFee + "" || "--") + "（元）\n保障期间： " + (item.productInsuranceYear + "" || "--") + " 年\n保单生效以后不能退保")))])]), _vm._v(" "), _c('div', [_vm._v("产品状态:\n          "), (item.productState == 1) ? _c('van-tag', {
      attrs: {
        "type": "success",
        "size": "large"
      }
    }, [_vm._v("正常")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "80px"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.toubaoViewOpen(item)
        }
      }
    }, [_vm._v("投保")])], 1)])]) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  })
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('ul', {
    staticClass: "partContent"
  }, [_c('li', [_c('span', {
    staticClass: "pcTitle"
  }, [_vm._v("产品名称：")]), _c('span', {
    staticClass: "pcContent"
  }, [_vm._v(_vm._s(_vm.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "photo",
    attrs: {
      "data-type": "1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("证件照上传")]), _vm._v(" "), _c('ul', {
    staticClass: "h5Camera"
  }, [_c('li', {
    staticClass: "front"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证正面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 1)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListFront),
      callback: function($$v) {
        _vm.fileListFront = $$v
      },
      expression: "fileListFront"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "behind"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证反面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 2)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListBack),
      callback: function($$v) {
        _vm.fileListBack = $$v
      },
      expression: "fileListBack"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("学员信息")]), _vm._v(" "), _c('ul', {
    staticClass: "partContent partContentLong"
  }, _vm._l((_vm.studentList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', [_vm._v("姓名："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      attrs: {
        "type": "text",
        "maxlength": "20",
        "placeholder": "请输入姓名"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v("身份证号："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cardId),
        expression: "item.cardId"
      }],
      staticClass: "width200",
      attrs: {
        "type": "text",
        "maxlength": "18",
        "placeholder": "请输入身份证号"
      },
      domProps: {
        "value": (item.cardId)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "cardId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v("手机号："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.mobile),
        expression: "item.mobile"
      }],
      attrs: {
        "type": "tel",
        "maxlength": "21",
        "placeholder": "请输入手机号"
      },
      domProps: {
        "value": (item.mobile)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "mobile", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "agreement",
    class: {
      'checked': _vm.agreeState
    },
    on: {
      "click": _vm.toAgree
    }
  }, [_c('i'), _vm._v("我已阅读并同意\n      "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(1)
      }
    }
  }, [_vm._v("《投保须知》")]), _c('br'), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(2)
      }
    }
  }, [_vm._v("《服务协议》")]), _c('br'), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(3)
      }
    }
  }, [_vm._v("《客户告知书》")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "feeTip"
  }, [_vm._v("需支付总金额：￥"), _c('span', [_vm._v(_vm._s(_vm.totalFee))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.submit('WXP')
      }
    }
  }, [_vm._v("微信支付")])], 1), _vm._v(" "), (_vm.payDialogVisible) ? _c('van-dialog', {
    attrs: {
      "title": ("请使用" + _vm.paymentTitle),
      "show-cancel-button": false,
      "show-confirm-button": false
    },
    model: {
      value: (_vm.payDialogVisible),
      callback: function($$v) {
        _vm.payDialogVisible = $$v
      },
      expression: "payDialogVisible"
    }
  }, [(_vm.payDialogVisible) ? _c('van-image', {
    staticStyle: {
      "width": "80%",
      "margin": "20px 10% 20px 10%"
    },
    attrs: {
      "src": _vm.payImgUrlList[0]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisibleProtocol) ? _c('van-dialog', {
    attrs: {
      "title": "",
      "show-cancel-button": true,
      "show-confirm-button": false
    },
    model: {
      value: (_vm.dialogVisibleProtocol),
      callback: function($$v) {
        _vm.dialogVisibleProtocol = $$v
      },
      expression: "dialogVisibleProtocol"
    }
  }, [(_vm.ruleTypes == 1) ? _c('tbxz') : (_vm.ruleTypes == 2) ? _c('fwxy') : _c('khgzs')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainContent"
  }, [_c('van-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.faqList), function(item, index) {
    return _c('van-collapse-item', {
      key: index,
      attrs: {
        "size": "large",
        "name": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('div', [_c('van-icon', {
            attrs: {
              "name": "question"
            }
          }), _vm._v(" " + _vm._s(item.question))], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(_vm._s(item.answer) + "\n      ")])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('ul', {
    staticClass: "partContent"
  }, [_c('li', [_c('span', {
    staticClass: "pcTitle"
  }, [_vm._v("产品名称：")]), _c('span', {
    staticClass: "pcContent"
  }, [_vm._v(_vm._s(_vm.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "photo",
    attrs: {
      "data-type": "1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("证件照上传")]), _vm._v(" "), _c('ul', {
    staticClass: "h5Camera"
  }, [_c('li', {
    staticClass: "front"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证正面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 1)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListFront),
      callback: function($$v) {
        _vm.fileListFront = $$v
      },
      expression: "fileListFront"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "behind"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证反面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 2)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListBack),
      callback: function($$v) {
        _vm.fileListBack = $$v
      },
      expression: "fileListBack"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("学员信息")]), _vm._v(" "), _c('ul', {
    staticClass: "partContent partContentLong"
  }, _vm._l((_vm.studentList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', [_vm._v("姓名："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      attrs: {
        "type": "text",
        "maxlength": "20",
        "placeholder": "请输入姓名"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v("身份证号："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cardId),
        expression: "item.cardId"
      }],
      staticClass: "width200",
      attrs: {
        "type": "text",
        "maxlength": "18",
        "placeholder": "请输入身份证号"
      },
      domProps: {
        "value": (item.cardId)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "cardId", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v("手机号："), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.mobile),
        expression: "item.mobile"
      }],
      attrs: {
        "type": "tel",
        "maxlength": "21",
        "placeholder": "请输入手机号"
      },
      domProps: {
        "value": (item.mobile)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "mobile", $event.target.value)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "agreement",
    class: {
      'checked': _vm.agreeState
    },
    on: {
      "click": _vm.toAgree
    }
  }, [_c('i'), _vm._v("我已阅读并同意\n    "), _c('br'), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(1)
      }
    }
  }, [_vm._v("《投保须知》")]), _c('br'), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(2)
      }
    }
  }, [_vm._v("《服务协议》")]), _c('br'), _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toRule(3)
      }
    }
  }, [_vm._v("《客户告知书》")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "feeTip"
  }, [_vm._v("需支付总金额：￥"), _c('span', [_vm._v(_vm._s(_vm.totalFee))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.submit('WXP')
      }
    }
  }, [_vm._v("微信支付")])], 1), _vm._v(" "), (_vm.payDialogVisible) ? _c('van-dialog', {
    attrs: {
      "title": ("请使用" + _vm.paymentTitle),
      "show-cancel-button": false,
      "show-confirm-button": false
    },
    model: {
      value: (_vm.payDialogVisible),
      callback: function($$v) {
        _vm.payDialogVisible = $$v
      },
      expression: "payDialogVisible"
    }
  }, [(_vm.payDialogVisible) ? _c('van-image', {
    staticStyle: {
      "width": "80%",
      "margin": "20px 10% 20px 10%"
    },
    attrs: {
      "src": _vm.payImgUrlList[0]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dialogVisibleProtocol) ? _c('van-dialog', {
    attrs: {
      "title": "",
      "show-cancel-button": true,
      "show-confirm-button": false
    },
    model: {
      value: (_vm.dialogVisibleProtocol),
      callback: function($$v) {
        _vm.dialogVisibleProtocol = $$v
      },
      expression: "dialogVisibleProtocol"
    }
  }, [(_vm.ruleTypes == 1) ? _c('tbxz') : (_vm.ruleTypes == 2) ? _c('fwxy') : _c('khgzs')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadingFlag) ? _c('div', [_c('div', {
    staticClass: "ajaxLoading"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-tip"
  }, [_vm._v(_vm._s(_vm.loadingText))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popupShowFlag) ? _c('div', {
    staticClass: "popupShow"
  }, [_vm._v(_vm._s(_vm.popupShowText))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-finish",
    style: ({
      height: _vm.isPhone ? 'calc(100vh - 120px)' : '570px'
    })
  }, [(_vm.isPhone) ? _c('div', {
    staticClass: "wrap2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "actionsWrap"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear2
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo2
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview2
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('canvas', {
    ref: "canvas2",
    staticClass: "canvas",
    staticStyle: {
      "flex": "1"
    }
  })]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "wrap1",
    staticStyle: {
      "margin-top": "0px",
      "height": "550px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('canvas', {
    ref: "canvas1",
    staticClass: "canvas1",
    staticStyle: {
      "width": "800px",
      "height": "400px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "danger",
    on: {
      "click": _vm.handleClear1
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('button', {
    staticClass: "warning",
    on: {
      "click": _vm.handleUndo1
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('button', {
    staticClass: "success",
    on: {
      "click": _vm.handlePreview1
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding": "10px",
      "text-align": "center",
      "transform": "translateY(-50%) rotate(90deg)",
      "width": "600px",
      "height": "20px",
      "position": "absolute",
      "top": "50%"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("支付")]), _vm._v(" 扫码，支付服务费\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "26px",
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n      请学员签署"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("本人姓名")]), _vm._v("授权"), _c('span', {
    staticStyle: {
      "font-size": "36px",
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("支付")]), _vm._v(" 扫码，支付服务费\n    ")])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, _vm._l((_vm.dataList), function(item, index) {
    return (!_vm.loading) ? _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('div', [_vm._v("凭证号: " + _vm._s(item.INSURANCE_NO))]), _vm._v(" "), _c('div', [_vm._v("补偿科目: " + _vm._s(item.CLAIM_CLASS_NAME))]), _vm._v(" "), _c('div', [_vm._v("补偿金额(元): " + _vm._s(item.CLAIM_FEE))]), _vm._v(" "), _c('div', [_vm._v("挂科时间: " + _vm._s(item.CLAIM_TIME))]), _vm._v(" "), _c('div', [_vm._v("申请日期: " + _vm._s(_vm.formatDate(item.CREATE_TIME)))]), _vm._v(" "), _c('div', [_vm._v("处理日期: " + _vm._s(_vm.formatDate(item.UPDATE_TIME)))]), _vm._v(" "), _c('div', [_vm._v("补偿状态:\n          "), _vm._v(" "), (item.CLAIM_STATUS == '0') ? _c('van-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '6') ? _c('van-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '1') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("资料收集成功，案件复核中")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '2') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("补偿中")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '3') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("打款成功")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '7') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("审核驳回")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '9') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("审核拒绝")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '12') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("打款失败")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '20') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("已报案")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._v("备注: " + _vm._s(item.CLAIM_STATUS == '1' ? "资料初审已通过，待复核通过后打款" : item.CLAIM_REFUSE))]), _vm._v(" "), (item.jjid != '' && item.jjid != null) ? _c('div', [_vm._v("加急状态: "), _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item.jjlx))])], 1) : _vm._e(), _vm._v(" "), ((item.CLAIM_STATUS == '1') && (item.jjid == '' || item.jjid == null) && _vm.isDict == 1) ? _c('div', [_c('van-button', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "size": "large",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.openFormEvent(item)
        }
      }
    }, [_vm._v("加急")])], 1) : _vm._e()]), _vm._v(" "), _c('van-popup', {
      style: ({
        height: '50%'
      }),
      attrs: {
        "position": "bottom",
        "close-on-click-overlay": false
      },
      model: {
        value: (_vm.openForm),
        callback: function($$v) {
          _vm.openForm = $$v
        },
        expression: "openForm"
      }
    }, [_c('van-form', [_c('van-field', {
      attrs: {
        "value": _vm.jjType,
        "name": "加急类型",
        "label": "加急类型",
        "readonly": "",
        "clickable": "",
        "placeholder": "请输入选择加急类型"
      },
      on: {
        "click": function($event) {
          _vm.showPicker = true
        }
      }
    }), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.showPicker),
        callback: function($$v) {
          _vm.showPicker = $$v
        },
        expression: "showPicker"
      }
    }, [_c('van-picker', {
      attrs: {
        "show-toolbar": "",
        "columns": _vm.sysDictList,
        "value-key": "dictName"
      },
      on: {
        "cancel": function($event) {
          _vm.showPicker = false
        },
        "confirm": _vm.onConfirm
      }
    })], 1), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.jjbj,
        "name": "加急比例(%)",
        "label": "加急比例(%)",
        "readonly": ""
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.jjje,
        "name": "服务费(元)",
        "label": "服务费(元)",
        "readonly": ""
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.paymentValue,
        "name": "支付方式",
        "label": "支付方式",
        "readonly": "",
        "clickable": "",
        "placeholder": "请输入选择加急类型"
      },
      on: {
        "click": function($event) {
          _vm.paymentTypeOpen = true
        }
      }
    }), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.paymentTypeOpen),
        callback: function($$v) {
          _vm.paymentTypeOpen = $$v
        },
        expression: "paymentTypeOpen"
      }
    }, [_c('van-picker', {
      attrs: {
        "show-toolbar": "",
        "columns": [{
            name: '支付宝',
            value: 'ALP'
          },
          {
            name: '微信',
            value: 'WXP'
          }
        ],
        "value-key": "name"
      },
      on: {
        "cancel": function($event) {
          _vm.paymentTypeOpen = false
        },
        "confirm": _vm.paymentBtn
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sign"
    }, [_c('a', {
      staticClass: "btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": _vm.gotoSign
      }
    }, [_vm._v(" 手写签名")])]), _vm._v(" "), _c('p', {
      staticClass: "protocol"
    }, [_c('van-checkbox', {
      attrs: {
        "icon-size": "18px"
      },
      on: {
        "change": _vm.readBook
      },
      model: {
        value: (_vm.checked),
        callback: function($$v) {
          _vm.checked = $$v
        },
        expression: "checked"
      }
    }, [_vm._v("同意\n            ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "16px",
        "display": "flex"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "30%",
        "margin": "0px 10%"
      },
      attrs: {
        "round": "",
        "block": "",
        "type": "info"
      },
      on: {
        "click": _vm.closePop
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('van-button', {
      staticStyle: {
        "width": "30%",
        "margin": "0px 10%"
      },
      attrs: {
        "round": "",
        "block": "",
        "type": "primary"
      },
      on: {
        "click": _vm.saveInfo
      }
    }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _c('van-dialog', {
      style: ({
        top: _vm.isPhone ? '50%' : ''
      }),
      attrs: {
        "title": "手写签名",
        "show-cancel-button": false,
        "showConfirmButton": false,
        "width": _vm.isPhone ? '100%' : '900px'
      },
      model: {
        value: (_vm.signShow),
        callback: function($$v) {
          _vm.signShow = $$v
        },
        expression: "signShow"
      }
    }, [_c('signer', {
      on: {
        "set-sign": _vm.setSign
      }
    })], 1), _vm._v(" "), (_vm.openImg) ? _c('van-dialog', {
      attrs: {
        "title": ("请使用" + _vm.openImgTitle + "扫码支付"),
        "show-cancel-button": ""
      },
      model: {
        value: (_vm.openImg),
        callback: function($$v) {
          _vm.openImg = $$v
        },
        expression: "openImg"
      }
    }, [(_vm.openImg) ? _c('van-image', {
      staticStyle: {
        "width": "80%",
        "margin": "20px 10% 20px 10%"
      },
      attrs: {
        "src": _vm.paymentUrl
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ruleContent"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("服务协议")]), _vm._v(" "), _c('p', [_vm._v("\n    您通过网络页面点击确认或同意接受《服务协议》（以下简称“本协议”），即视为您与云南祐祉商务信息咨询有限公司已达成合意并接受本协议约定的内容。在您确认接受本协议前，请您务必审慎阅读并充分理解本协议各条款的内容，尤其是免除或限制责任的条款、法律适用与管辖条款。免除或限制责任的条款将以粗体标识，您应重点阅读。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("如果您对协议内容有任何的疑问，可联系我们进行咨询。在您确认接受本协议全部条款之前，请勿进行下一步操作。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("一、服务提示")]), _vm._v(" "), _c('p', [_vm._v("1.请您在投保前，认真评估保障需求，根据实际需要合理选择金融产品。如果您对金融产品的选择有任何的疑问，您可通过平台微信公众号、客服电话、进行咨询，云南祐祉商务信息咨询有限公司学驾易平台将为您提供专业的咨询服务。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.请您在购买前，务必认真阅读保险条款和投保须知等内容，了解保险责任、责任免除、等重要内容。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.请您在购买前，认真阅读告知书并履行如实告知义务。若您未履行如实告知义务，将有权解除保险合同，并对保险合同解除前发生的保险事故不承担保险责任。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("4.您通过本服务从事的交易可能面临以下风险，这些风险需要您自行承担：")]), _vm._v(" "), _c('p', [_vm._v("(1)监管风险：法律法规､监管政策和规定发生变化，导致您的交易目的无法实现，您由此可能遭受损失；")]), _vm._v(" "), _c('p', [_vm._v("(2)违约风险：因无力或其他原因不能履约，您由此可能遭受损失；")]), _vm._v(" "), _c('p', [_vm._v("(3)交易风险：您通过本服务所购买的保险产品最终没有达成交易，您无法获得保险产品和服务；")]), _vm._v(" "), _c('p', [_vm._v("(4)过错风险：因您的过错导致的任何损失，包括但不限于决策失误、不诚信行为、操作不当、遗忘或泄漏密码、非本人操作或委托不当等。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("5.您在云南祐祉商务信息咨询有限公司旗下学驾易平台提供或填写的信息（包括但不限于注册信息、投保信息等）应是真实、准确、合法有效的，如有变化，您应及时修改并重新提交。若因您提交的信息不真实、不准确、不合法或失效，您应承担由此引起的不利后果。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("6.您同意并授权云南祐祉商务信息咨询有限公司旗下学驾易平台开通客户资金专用账户通过微信支付等第三方支付机构收取保费并按照与的约定将保费解付至。")]), _vm._v(" "), _c('p', [_vm._v("二、协议的范围与性质")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1.本协议是您与学驾易平台之间订立的委托协议，而保险合同的订立和履行由您和共同合意完成。学驾易平台基于您的合法权益，为您和之间订立保险合同提供信息、科技服务。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.本协议是您与云南祐祉商务信息咨询有限公司旗下学驾易平台之间关于学驾易平台服务所订立的协议。学驾易平台相关服务可能存在的运营关联单位同样在本协议中享有学驾易平台的权益；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.您在使用学驾易平台某一项服务时，该服务可能会另有单独的协议、业务规则等。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守；")]), _vm._v(" "), _c('p', [_vm._v("4.您在学驾易平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。学驾易平台和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("三、协议的生效、变更与转让")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1.您通过公众号页面点击确认或同意接受本协议，或使用学驾易平台的服务即视为您已阅读本协议并接受本协议的约束，本协议即刻生效；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.鉴于互联网服务的特殊性，您同意并授权学驾易平台根据国家法律法规和政策的变化及时修订本协议。修订后的协议将通过原有展示方式向您公布，如您对本协议的修订有任何的疑问，可以联系学驾易平台进行咨询；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.本协议条款修改或变更后，如果您继续使用学驾易平台提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用学驾易平台提供的软件或服务；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("4.除非您与学驾易平台另有约定外，您同意本服务仅为您本人使用，您依本协议条款所取得的权利不可转让。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("四、个人信息保护")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n    保护您的个人信息是学驾易平台的一项核心原则。学驾易平台将按照本协议及《隐私政策》的规定收集、使用、储存、分享您的个人信息。本协议内容同时包括《隐私政策》，即为本协议不可分割的组成部分，您对本协议的接受，即视为您对《隐私政策》的接受。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v(" 五、行为规范")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1.您在使用本服务时须遵守法律法规，不得利用本服务从事洗钱、窃取商业秘密、窃取个人信息等违法违规活动；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.您不得利用学驾易平台提供的服务从事任何牟利或经营活动；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("4.您不得使用未经学驾易平台授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("5.您违反本条约定，导致学驾易平台或第三方损害的，您应当独立承担一切责任，包括但不限于：刑事责任、行政责任和民事责任。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("六、免责事由")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n    1.您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，学驾易平台将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失学驾易平台在法律允许的范围内免责；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.您同意下列情形已超出学驾易平台控制与合理预见，若因此给您造成了损失，学驾易平台可以免责：　　")]), _vm._v(" "), _c('p', [_vm._v("(1)您受到病毒、木马或其他恶意程序、黑客攻击的破坏；　　")]), _vm._v(" "), _c('p', [_vm._v("(2)您的手机、电脑软件、系统、硬件和通信线路出现故障；　")]), _vm._v(" "), _c('p', [_vm._v("(3)您通过非鼎和保险平台授权的方式使用本服务；")]), _vm._v(" "), _c('p', [_vm._v("(4)您未点击和阅读保险条款、投保须知等内容；")]), _vm._v(" "), _c('p', [_vm._v("(5)学驾易平台平台页面展示和设计原因给您造成损失；")]), _vm._v(" "), _c('p', [_vm._v("(6)学驾易平台平台系统原因导致您未成功投保、续保或支付保费；")]), _vm._v(" "), _c('p', [_vm._v("(7)学驾易平台平台系统不稳定或故障、通讯故障、银行原因、第三方服务瑕疵。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.除上述免责情形外，非因鼎和保险平台故意或重大过失给您造成损失的，学驾易平台也可以免责。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("七、服务的变更、中断、终止")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1.学驾易平台可能会对服务内容进行变更，也可能会中断、中止或终止服务；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.您理解并同意，在学驾易平台发生合并、分立、收购、资产转让时，学驾易平台可向第三方转让本服务下相关资产学驾易平台也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行；")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("3.如发生下列任何一种情形，学驾易平台有权不经通知而中断或终止向您提供的服务：")]), _vm._v(" "), _c('p', [_vm._v("（1）您提供的个人资料不真实、不准确、不合法或失效；")]), _vm._v(" "), _c('p', [_vm._v("（2）您违反相关法律法规或本协议的约定；　　")]), _vm._v(" "), _c('p', [_vm._v("（3）按照法律规定或主管部门的要求。　")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("八、法律适用与管辖")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1.本协议的订立、效力、解释、履行及争议的解决均适用中华人民共和国法律。因本协议引起的或与本协议有关的任何争议，应首先通过协商方式解决。协商不成的，应将争议提交至云南祐祉商务信息咨询有限公司地址人民法院通过诉讼方式解决。")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("2.本协议名称、条款的标题仅为查阅方便而设置，不应构成对本协议的任何解释，不对标题之下的内容及范围作任何限定。")]), _vm._v(" "), _c('p')])
}]}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "detail"
    }
  }, [_c('div', [_c('van-search', {
    attrs: {
      "shape": "round",
      "background": "#2486ff",
      "placeholder": "能搜出来的银行为可打款银行"
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "background-color": "rgba(255, 255, 255, 1)",
      "z-index": "10",
      "height": "320px",
      "overflow-y": "auto",
      "width": "95%"
    }
  }, _vm._l((_vm.subBankList), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding-bottom": "1rem"
      }
    }, [_c('li', {
      staticStyle: {
        "text-align": "center",
        "line-height": "20px",
        "height": "20px",
        "padding": "0",
        "display": "block"
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("凭证号")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceNo))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("产品名称")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.productName ? (_vm.userInfo.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.userInfo.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)") : ""))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("开始日期")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceStartTime))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("结束日期")]), _c('span', {
    staticClass: "spanR",
    staticStyle: {
      "color": "#f60f60"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceEndTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-note"
  }, [_vm._v("\n        温馨提示：\n        " + _vm._s(_vm.userInfo.userName) + "学员您好！在操作补偿前，务必先查好开户行支行信息，补偿时必须提供，查询方式打银行卡背面客服电话查询，银行会以短信形式发送，尽量为四大银行，如非四大行可在上方搜索，是否符合收款账户。\n        如在上方搜索框无法匹配到您所填写的银行，请更换本人收款银行。\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.toClaim
    }
  }, [_vm._v("申请补偿")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("返回个人信息")]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px",
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('a', {
    attrs: {
      "href": "./learn"
    }
  }, [_vm._v("视频教程")])])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('van-button', {
    staticStyle: {
      "margin-bottom": "20px",
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(0)
      }
    }
  }, [_vm._v("学员登录")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "border-radius": "5px",
      "height": "60px",
      "font-size": "20px"
    },
    attrs: {
      "type": "info",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXueyuan(1)
      }
    }
  }, [_vm._v("驾校登录")])], 1)
},staticRenderFns: []}

/***/ }),
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[265]);


// WEBPACK FOOTER //
// static/js/app.837dfe287b7375c1f40a.js